export const translations = {
  pt: {
    "common.user": "Utilizador",
    "common.event": "Evento",
    "common.unknown": "Desconhecido",
    "common.confirm": "Confirmar",
    "common.cancel": "Cancelar",
    "common.delete": "Apagar",
    "settings.title": "Definições",
    "settings.account.title": "Conta",
    "settings.account.sessionActiveAs": "Sessão ativa como:",
    "settings.account.updateProfile": "Atualizar Perfil",
    "settings.account.manageSubscription": "Gerir Subscrição",
    "settings.account.signOut": "Terminar sessão",
    "settings.account.signingOut": "A sair…",
    "settings.account.noSession": "Sem sessão ativa.",
    "settings.account.signIn": "Iniciar sessão",
    "settings.wallet.title": "Carteira",
    "settings.wallet.description": "Carrega saldo para usar nas inscrições dos próximos eventos, ou acumula para uma aventura futura.",
    "settings.wallet.sending": "A enviar email...",
    "settings.wallet.paymentLink": "Receber link de pagamento no email",
    "settings.wallet.coupons": "Ver cupões",
    "settings.heartRate.title": "Frequência cardíaca",
    "settings.heartRate.description": "Escolhe a fonte usada durante a gravação. Automático liga-se à primeira fonte compatível disponível.",
    "settings.heartRate.preferredSource": "Fonte preferida",
    "settings.heartRate.auto": "Automático (recomendado)",
    "settings.heartRate.authorizeAppleHealth": "Autorizar Apple Saúde",
    "settings.maps.title": "Mapas",
    "settings.maps.subtitle": "Mapa base utilizado na app.",
    "settings.maps.cacheNote":
      "Os mapas ficam guardados no dispositivo e são limpos após {ttl} sem uso.",
    "settings.maps.lite": "Mapa Lite PT",
    "settings.maps.pro": "Mapa Pro PT",
    "settings.maps.download": "Download",
    "settings.maps.downloading": "A descarregar",
    "settings.maps.noPermission": "Sem permissão",
    "settings.maps.downloaded": "Descarregado",
    "settings.maps.source": "Origem",
    "settings.maps.source.auto": "Automático",
    "settings.maps.source.local": "Descarregado",
    "settings.maps.source.remote": "Online",
    "settings.maps.source.activeLocal": "Em utilização: mapa descarregado",
    "settings.maps.source.activeRemote": "Em utilização: cache e mapa online",
    "settings.maps.clearMaps": "Limpar mapas",
    "settings.maps.clearing": "A limpar",
    "settings.maps.confirmDelete": "Eliminar mapas descarregados?",
    "settings.maps.adminOnly": "Apenas para gestão/admin.",
    "settings.maps.contours": "Curvas de nível",
    "settings.maps.missing": "em falta",
    "settings.maps.clearCache": "Limpar cache",
    "settings.support.title": "Ajuda e suporte",
    "settings.support.description": "Encontraste uma falha? Envia-nos uma descrição e, se possível, imagens.",
    "settings.support.report": "Reportar um problema",
    "settings.support.myReports": "Os meus reportes",
    "myReports.title": "Os meus reportes",
    "myReports.subtitle": "Acompanha os problemas que enviaste e o respetivo estado.",
    "myReports.empty": "Ainda não enviaste nenhum reporte.",
    "myReports.status.pending": "Enviado",
    "myReports.status.in_progress": "Em análise",
    "myReports.status.validation": "Em validação",
    "myReports.status.resolved": "Resolvido",
    "myReports.status.dismissed": "Encerrado",
    "myReports.adminNote": "Resposta da equipa",
    "myReports.comment": "Comentário",
    "myReports.commentPlaceholder": "Adiciona uma nota sobre a correção ou explica o que continua a acontecer…",
    "myReports.confirm": "Confirmar correção",
    "myReports.reopen": "Reabrir reporte",
    "issueReport.title": "Reportar um problema",
    "issueReport.subtitle": "Ajuda-nos a perceber e corrigir a falha.",
    "issueReport.problem": "Problema",
    "issueReport.category": "Categoria",
    "issueReport.category.bug": "Erro / falha",
    "issueReport.category.gps": "GPS / gravação",
    "issueReport.category.maps": "Mapas / navegação",
    "issueReport.category.account": "Conta / pagamentos",
    "issueReport.category.suggestion": "Sugestão",
    "issueReport.category.other": "Outro",
    "issueReport.description": "O que aconteceu?",
    "issueReport.descriptionPlaceholder": "Diz-nos o que estavas a fazer, o que esperavas que acontecesse e o que aconteceu...",
    "issueReport.images": "Imagens",
    "issueReport.imagesHint": "(opcional, máximo {max})",
    "issueReport.addImage": "Adicionar imagem",
    "issueReport.technicalInfo": "A versão da app, plataforma e informação técnica do dispositivo serão incluídas automaticamente. Não são enviados dados de localização GPS.",
    "issueReport.submitting": "A submeter...",
    "issueReport.submit": "Submeter",
    "settings.maps.toast.noPermissionDownloadLite":
      "❗ Sem permissão para descarregar o mapa Lite.",
    "settings.maps.toast.noPermissionDownloadPro":
      "❗ Sem permissão para descarregar o mapa Pro.",
    "settings.maps.toast.downloadUnavailable":
      "Download indisponivel neste dispositivo.",
    "settings.maps.toast.liteAlreadyDownloaded": "Mapa Lite já descarregado.",
    "settings.maps.toast.proAlreadyDownloaded": "Mapa Pro já descarregado.",
    "settings.maps.toast.downloadFailed": "Falha ao descarregar mapa.",
    "settings.maps.toast.liteDownloaded": "Mapa Lite descarregado.",
    "settings.maps.toast.proDownloaded": "Mapa Pro descarregado.",
    "settings.maps.toast.mapsRemoved": "Mapas removidos da memoria.",
    "settings.maps.toast.clearFailed": "Falha ao limpar mapas.",
    "settings.maps.toast.localUnavailable":
      "Descarrega primeiro o mapa selecionado para utilizar este modo.",
    "settings.maps.toast.noPermissionUseLite":
      "❗ Sem permissão para usar o mapa Lite.",
    "settings.maps.toast.noPermissionUsePro":
      "❗ Sem permissão para usar o mapa Pro.",
    "settings.alerts.title": "Alertas",
    "settings.alerts.chatMessages": "Alertas de mensagens de grupo e diretas",
    "settings.alerts.offTrail": "Ativar alerta fora do trilho",
    "settings.alerts.offTrailThreshold": "Distância do alerta",
    "settings.alerts.proximity": "Alertas de proximidade",
    "settings.alerts.fauna": "Alertas de fauna",
    "settings.alerts.trail": "Alertas de trilho",
    "settings.alerts.security": "Alertas de segurança",
    "settings.alerts.feedbackMode": "Modo do alerta",
    "settings.alerts.feedback.both": "Som + vibração",
    "settings.alerts.feedback.vibrate": "Apenas vibração",
    "settings.alerts.feedback.sound": "Apenas som",
    "settings.alerts.vibrate": "Vibrar alertas",
    "settings.alerts.sound": "Som dos alertas",
    "settings.alerts.critical": "Alertas críticos",
    "settings.push.description":
      "Se deixaste de receber notificações, volta a autorizar este dispositivo e renova o token de entrega.",
    "settings.push.reactivate": "Reativar notificações push",
    "settings.push.reactivating": "A reativar…",
    "settings.push.reactivated": "Notificações push reativadas neste dispositivo.",
    "settings.push.permissionDenied":
      "As notificações estão bloqueadas. Ativa-as nas definições do dispositivo ou navegador e tenta novamente.",
    "settings.push.failed": "Não foi possível reativar as notificações push.",
    "settings.build.dev": "— dev build —",
    "bars.navigate": "Navegar",
    "bars.events": "Eventos",
    "bars.guides": "Guias",
    "bars.account": "Conta",
    "bars.admin": "Admin",
    "topBar.show": "Mostrar",
    "topBar.hide": "Ocultar",
    "topBar.compass": "Bússola",
    "topBar.help": "Ajuda",
    "topBar.chat": "Chat",
    "topBar.center": "Centrar",
    "topBar.network": "Rede",
    "topBar.points": "Pontos",
    "topBar.alerts": "Alertas",
    "topBar.clear": "Limpar",
    "topBar.clearTrails": "Limpar trilhos do mapa",
    "nav.recording.activity": "Atividade",
    "nav.recording.walk": "Caminhada",
    "nav.recording.bike": "Bicicleta",
    "nav.recording.mode": "Modo",
    "nav.recording.normal": "Normal",
    "nav.recording.expedition": "Expedição",
    "nav.recording.precision": "Precisão",
    "nav.recording.balanced": "Equilibrado",
    "nav.recording.battery": "Economia",
    "nav.recording.expeditionDescription": "Durante a gravação, desliga Live Share, eventos live e telemetria remota. Ao finalizar, sincroniza normalmente.",
    "nav.recording.normalDescription": "Modo completo com sincronização e funcionalidades remotas permitidas.",
    "nav.recording.locked": "O modo fica bloqueado até terminares esta gravação.",
    "nav.stopConfirm.title": "Terminar gravação",
    "nav.stopConfirm.text": "Queres terminar e guardar esta gravação?",
    "nav.stopConfirm.action": "Terminar",
    "nav.availableTrails": "Ver trilhos disponíveis",
    "nav.missions": "Missões e Recompensas",
    "nav.showTrailsMap": "Mostrar trilhos no mapa",
    "nav.hideTrailsMap": "Ocultar trilhos no mapa",
    "guide.ratings.noPublicScore": "Sem pontuação pública",
    "guide.ratings.latest": "Últimas avaliações",
    "guide.ratings.confirmHint": "Confirma as novas avaliações depois de as consultares.",
    "guide.ratings.newSingle": "nova avaliação",
    "guide.ratings.newPlural": "novas avaliações",
    "guide.ratings.noneNew": "Não tens avaliações novas.",
    "guide.featured.title": "Os mais procurados",
    "guide.title": "Guias & Grupos",
    "guide.availableGuides.title":
      "Guias disponíveis para criar aventuras e grupos privados.",
    "guide.actions.chat": "Chat",
    "guide.actions.about": "Sobre",
    "guide.about.title": "Sobre o guia",
    "guide.about.empty": "Este guia ainda não adicionou descrição.",
    "guide.about.close": "Fechar",
    "guide.description.autoSync":
      "Os grupos agora são sincronizados automaticamente pelos eventos. Entra no evento, e o teu grupo é atualizado sem intervenção manual.",
    "guide.direct.empty": "— Sem contactos diretos —",
    "guide.direct.label": "Chat direto",
    "guide.globalChat.title": "Chat Global",
    "guide.globalChat.subtitle.noneYet": "— Sem mensagens ainda —",
    "guide.globalChat.subtitle.newMessages": "— Novas mensagens —",
    "guide.globalChat.subtitle.noNewMessages": "— Sem mensagens novas —",
    "guide.createGroup.title": "Criar novo grupo",
    "guide.createGroup.placeholder": "Nome do grupo",
    "guide.groups.title": "Todos os grupos",
    "guide.groups.empty": "Ainda não tens grupos.",
    "guide.groups.upcoming": "Próximos eventos",
    "guide.groups.past": "Eventos passados",
    "guide.note.autoParticipation":
      "A tua participação é definida automaticamente pelos eventos a que te inscreves.",
    "guide.online.title": "Guia On-Line",
    "guide.online.subtitle": "Sessões privadas com guia, marcadas por pedido.",
    "guide.online.requestButton": "Submeter pedido",
    "guide.trailProposal.submit": "Submeter pedido",
    "guide.trailProposal.title": "Proposta de trilho personalizado.",
    "guide.trailProposal.subtitle": "Eventos privados com guia no terreno, personalizados à sua medida.",
    "guide.partnerAccommodation.title": "Alojamentos parceiros",
    "guide.partnerAccommodation.item": "Alojamento parceiro",
    "guide.partnerAccommodation.view": "Ver",
    "guide.bicycleAssistance.title": "Assistência e Aluguer de bicicletas",
    "guide.bicycleAssistance.item": "Assistência e Aluguer de bicicletas",
    "guide.bicycleAssistance.view": "Ver",
    "guide.pending.onlineTitle": "Pedidos pendentes — Guia On-Line",
    "guide.pending.trailTitle": "Pedidos pendentes — Proposta de trilho",
    "guide.online.pricing.insurance": "Seguro por pessoa",
    "guide.online.pricing.hour": "Preço por hora/pessoa",
    "guide.online.form.title": "Pedido Guia On-Line",
    "guide.online.form.subtitle": "Preenche os dados para submeter o pedido.",
    "guide.online.form.name": "Nome completo",
    "guide.online.form.email": "Email",
    "guide.online.form.phone": "Telemóvel",
    "guide.online.form.peopleCount": "Nº de pessoas",
    "guide.online.form.requestedHours": "Horas pretendidas",
    "guide.online.form.startTime": "Data e hora de início",
    "guide.online.form.meetingPoint": "Ponto de encontro",
    "guide.online.form.pickPoint": "Selecionar no mapa",
    "guide.online.form.selectedPoint": "Selecionado:",
    "guide.online.form.routeDescription":
      "Qual o tipo de percurso pretendido?",
    "guide.online.form.guestEmails": "Emails dos participantes",
    "guide.online.form.guestEmailsHint": "ex: ana@email.com, joao@email.com",
    "guide.online.form.includeInsurance": "Quero incluir seguro",
    "guide.online.form.estimate": "Estimativa",
    "guide.online.form.estimateNote":
      "Valor estimado antes de submissão. O pagamento só é pedido após aceitação do guia.",
    "guide.online.form.submit": "Submeter pedido",
    "guide.online.form.submitting": "A submeter…",
    "guide.online.myRequests": "Os meus pedidos",
    "guide.online.pending.title": "Pedidos pendentes",
    "guide.online.pending.empty": "Sem pedidos pendentes.",
    "guide.online.pending.accept": "Aceitar",
    "guide.online.pending.reject": "Recusar",
    "guide.online.status.pending": "Pendente",
    "guide.online.status.accepted": "Aceite",
    "guide.online.status.rejected": "Recusado",
    "guide.online.status.placeFallback": "Ponto selecionado",
    "guide.online.labels.people": "pessoas",
    "guide.online.labels.hours": "horas",
    "guide.online.toast.authRequired": "Precisas de estar autenticado para pedir um guia.",
    "guide.online.toast.pointSelected": "Ponto selecionado.",
    "guide.online.toast.missingFields": "Preenche todos os campos obrigatórios.",
    "guide.online.toast.sent":
      "Pedido enviado. Vais receber confirmação quando o guia aceitar.",
    "guide.online.toast.error": "Não foi possível enviar o pedido.",
    "guide.online.delete.confirm": "Eliminar este pedido?",
    "guide.online.delete.confirmAccepted":
      "Eliminar este pedido e apagar o grupo e evento associados?",
    "guide.online.delete.toast.success": "Pedido eliminado.",
    "guide.online.delete.toast.error": "Não foi possível eliminar o pedido.",
    "guide.online.delete.notAllowed":
      "Não tens permissões para eliminar um pedido aceite.",
    "guide.online.payment.pay": "Pagar",
    "guide.online.payment.paid": "Pago",
    "guide.online.payment.free": "Oferta",
    "guide.online.payment.loading": "A abrir…",
    "guide.online.payment.toast.error": "Não foi possível criar o pagamento.",
    "guide.online.payment.toast.noApi": "API indisponível para pagamento.",
    "guide.online.accept.title": "Aceitar pedido",
    "guide.online.accept.hours": "Horas a cobrar",
    "guide.online.accept.pricePerHour": "Preço por hora/pessoa",
    "guide.online.accept.insurancePerPerson": "Seguro por pessoa",
    "guide.online.accept.offer": "Sessão oferta (sem pagamento)",
    "guide.online.accept.total": "Total",
    "guide.online.accept.confirm": "Confirmar",
    "guide.online.accept.saving": "A guardar…",
    "guide.online.accept.toast.success": "Pedido aceite com sucesso.",
    "guide.online.accept.toast.error": "Falha ao aceitar o pedido.",
    "guide.online.details.title": "Detalhes do pedido",
    "guide.online.details.none": "—",
    "guide.online.details.insuranceIncluded": "Seguro incluído",
    "guide.online.details.insuranceExcluded": "Sem seguro",
    "guide.online.reject.title": "Recusar pedido",
    "guide.online.reject.reason": "Motivo da recusa",
    "guide.online.reject.placeholder": "Descreve o motivo para o utilizador.",
    "guide.online.reject.confirm": "Recusar",
    "guide.online.reject.saving": "A recusar…",
    "guide.online.reject.toast.success": "Pedido recusado com sucesso.",
    "guide.online.reject.toast.error": "Falha ao recusar o pedido.",
    "guide.online.reject.toast.missingReason": "Indica um motivo para recusar.",
    "guide.online.reject.reasonLabel": "Motivo",
    "guide.online.group.namePrefix": "Guia On-Line -",
    "guide.online.group.placeFallback": "Ponto selecionado",
    "guide.online.event.namePrefix": "Guia On-Line",
    "guide.group.ownerLabel": "Guia:",
    "guide.group.descriptionFallback": "Sem descrição definida.",
    "guide.group.status.member": "És membro — podes entrar no chat.",
    "guide.group.status.visible":
      "Grupo visível — o evento tratará da tua entrada.",
    "guide.confirm.deleteGroup": "Eliminar o grupo \"{name}\"?",
    "directChat.alert.planNotAllowed": "❗ O teu plano não permite chat direto. Subscreve Explorer, Adventure ou Guide.",
    "settings.appearance": "Aparência",
    "settings.language": "Idioma",
    "settings.theme.system": "Sistema",
    "settings.theme.light": "Claro",
    "settings.theme.dark": "Escuro",
    "profile.title": "Perfil Trekkin",
    "profile.noUser": "Nenhum utilizador autenticado.",
    "profile.accountSection": "Conta Trekkin",
    "profile.displayNameFallback": "Trekker sem nome",
    "profile.requiredData": "Dados obrigatórios para atividades guiadas.",
    "profile.personalData": "Dados pessoais",
    "profile.fullName": "Nome completo",
    "profile.email": "Email",
    "profile.phone": "Telemóvel",
    "profile.dob": "Data de nascimento",
    "profile.weight": "Peso",
    "profile.ccNumber": "Número de CC",
    "profile.ccPlaceholder": "Número do Cartão de Cidadão",
    "profile.emergencyContact": "Contacto de emergência",
    "profile.emergencyPlaceholder": "Nome + telefone",
    "profile.guideDescription": "Descrição de guia",
    "profile.guideDescriptionPlaceholder":
      "Fala um pouco sobre ti, experiência e estilo de guiagem.",
    "profile.alerts": "Alertas",
    "profile.offTrail": "Ativar alerta fora do trilho (40 m)",
    "profile.proximityAlerts": "Receber alertas de proximidade",
    "profile.faunaAlerts": "Receber alertas de Fauna",
    "profile.trailAlerts": "Receber alertas de Trilho",
    "profile.securityAlerts": "Receber alertas de Segurança",
    "profile.vibrateAlerts": "Vibrar ao aproximar",
    "profile.soundAlerts": "Som ao aproximar",
    "profile.criticalAlerts": "Receber alertas Críticos",
    "profile.saving": "A guardar...",
    "profile.save": "Guardar alterações",
    "profile.logout": "Terminar sessão",
    "profile.deleteTitle": "⚠️ Eliminar conta",
    "profile.deleteBody":
      "Esta ação é permanente e irá eliminar a tua conta e todos os dados associados (perfil, trilhos, mensagens e registos).",
    "profile.deleteButton": "Eliminar conta definitivamente",
    "profile.deleteModalTitle": "Eliminar conta",
    "profile.deleteModalBody":
      "Ao eliminar a tua conta, todos os teus dados serão apagados permanentemente, incluindo:",
    "profile.deleteModalItem1": "Perfil e dados pessoais",
    "profile.deleteModalItem2": "Trilhos e histórico",
    "profile.deleteModalItem3": "Mensagens e grupos",
    "profile.deleteModalItem4": "Registos e partilhas",
    "profile.deleteModalWarning":
      "Esta ação é irreversível e não pode ser desfeita.",
    "profile.deleteModalConfirm": "Eliminar conta definitivamente",
    "profile.deleteModalLoading": "A eliminar conta...",
    "profile.cancel": "Cancelar",
    "profile.photoUploadError": "❌ Erro ao enviar foto.",
    "profile.photoUpdateSuccess": "✅ Foto atualizada!",
    "profile.photoUpdateError": "❌ Erro ao atualizar foto.",
    "profile.profileUpdateSuccess": "✅ Perfil atualizado!",
    "profile.profileUpdateError": "❌ Erro ao guardar.",
    "profile.trophies.open": "Visualizar os eventos que estive presente",
    "profile.trophies.modalTitle": "As minhas participações",
    "profile.trophies.modalSubtitle":
      "Eventos onde estive presente ({count})",
    "profile.trophies.empty": "Ainda não tens participações registadas.",
    "profile.trophies.dateUnknown": "Data por definir",
    "profile.trophies.actionTitle": "Participação",
    "profile.trophies.actionSubtitle": "Escolhe o que queres abrir para {event}.",
    "profile.trophies.actionViewEvent": "Ver evento",
    "profile.trophies.actionGallery": "Galeria",
    "profile.trophies.galleryTitle": "Galeria da participação",
    "profile.trophies.gallerySubtitle": "{event} • {count} foto(s)",
    "profile.trophies.galleryUploader": "Carregar fotos para partilhar com os participantes",
    "profile.trophies.galleryUploadLabel": "Podes carregar mais {remaining} foto(s) para esta participação.",
    "profile.trophies.galleryLimitReached": "Já atingiste o limite de 10 fotos nesta participação.",
    "profile.trophies.galleryLoading": "A carregar galeria...",
    "profile.trophies.galleryEmpty": "Ainda não há fotos neste álbum.",
    "profile.trophies.galleryUploadSaved": "✅ Foto adicionada à galeria da participação.",
    "profile.trophies.galleryUploadError": "❌ Erro ao guardar foto na galeria.",
    "profile.trophies.galleryDelete": "Eliminar",
    "profile.trophies.galleryDeleting": "A eliminar...",
    "profile.trophies.galleryDeleteSuccess": "✅ Foto eliminada da galeria.",
    "profile.trophies.galleryDeleteError": "❌ Erro ao eliminar foto da galeria.",
    "profile.deleteSuccess": "✅ Conta eliminada com sucesso.",
    "profile.deleteLoginRequired":
      "❌ Por segurança, faz login novamente e tenta outra vez.",
    "profile.deleteError": "❌ Erro ao eliminar conta.",
    "forgot.title": "Recuperar password",
    "forgot.description": "Introduz o email da tua conta Trekkin.",
    "forgot.placeholderEmail": "O teu email",
    "forgot.sending": "A enviar...",
    "forgot.sendLink": "Enviar link de recuperação",
    "forgot.backToLogin": "Voltar ao login",
    "forgot.toast.invalidEmail": "❗ Escreve um email válido.",
    "forgot.toast.sent": "📩 Enviámos um link de recuperação para o teu email.",
    "forgot.toast.error": "❌ Erro ao enviar email de recuperação.",
    "share.alert.authRequired": "Precisas de estar autenticado para partilhar.",
    "logs.alert.empty": "Sem logs para exportar.",
    "logs.alert.exportError": "Erro ao exportar logs.",
    "groupChat.alert.sendFail": "Falha ao enviar. Verifica a internet.",
    "groupChat.alert.reported": "Mensagem reportada. Obrigado.",
    "groupChat.alert.reportFail": "Falha ao reportar. Tenta novamente.",
    "groupChat.alert.userBlocked": "Utilizador bloqueado.",
    "groupChat.alert.blockFail": "Falha ao bloquear.",
    "chat.action.reply": "Responder",
    "chat.action.report": "Reportar mensagem",
    "chat.action.block": "Bloquear utilizador",
    "chat.action.unblock": "Desbloquear",
    "chat.action.delete": "Eliminar mensagem",
    "chat.reactions.title": "Reações",
    "chat.reactions.close": "Fechar reações",
    "chat.reactions.show": "Ver quem reagiu ({count})",
    "chat.reactions.loading": "A carregar…",
    "chat.reactions.unknownUser": "Utilizador",
    "globalChat.alert.sendFail": "Falha ao enviar. Verifica a internet.",
    "globalChat.alert.reported": "Mensagem reportada. Obrigado.",
    "globalChat.alert.reportFail": "Falha ao reportar. Tenta novamente.",
    "globalChat.alert.userBlocked": "Utilizador bloqueado.",
    "globalChat.alert.blockFail": "Falha ao bloquear. Tenta novamente.",
    "directChat.alert.sendFail": "Erro ao enviar mensagem.",
    "directChat.alert.startFail": "Não foi possível iniciar novo chat.",
    "adminReports.alert.updateFail": "Falha ao atualizar report.",
    "adminReports.alert.resolved": "Mensagem removida e report resolvido.",
    "adminReports.alert.removeFail": "Falha ao remover mensagem.",
    "adminReports.deletedMessage": "[mensagem removida pelo moderador]",
    "guide.alert.groupNameRequired": "Dá um nome ao grupo!",
    "guide.alert.createGroupFail": "Não foi possível criar o grupo.",
    "guide.alert.membersOnly": "Só membros do grupo podem usar o chat.",
    "guide.alert.openChatFail": "Não foi possível abrir o chat deste grupo.",
    "login.title.register": "Criar Conta Trekkin",
    "login.title.login": "Iniciar Sessão",
    "login.placeholder.email": "Email",
    "login.placeholder.password": "Palavra-passe",
    "login.placeholder.confirmPassword": "Confirmar palavra-passe",
    "login.placeholder.firstName": "Primeiro nome",
    "login.placeholder.lastName": "Apelido",
    "login.placeholder.username": "Nome de utilizador (ex: trekkinlord)",
    "login.terms.prefix": "Li e aceito os",
    "login.terms.linkText": "Termos de Utilização",
    "login.terms.suffix":
      ", incluindo a política de tolerância zero a conteúdo abusivo ou ofensivo.",
    "login.button.wait": "Aguarde…",
    "login.button.register": "Criar Conta",
    "login.button.login": "Entrar",
    "login.toggle.toLogin": "Já tenho conta — entrar",
    "login.toggle.toRegister": "Ainda não tenho conta — criar",
    "login.forgot": "Esqueci-me da palavra-passe",
    "login.msg.fillAll": "⚠️ Preenche todos os campos.",
    "login.msg.passwordMismatch": "⚠️ As palavras-passe não coincidem.",
    "login.msg.usernameInvalid":
      "⚠️ Username inválido. Usa apenas letras minúsculas, números e underscore (3–20 chars).",
    "login.msg.acceptTerms": "⚠️ Tens de aceitar os Termos de Utilização.",
    "login.msg.registerSuccess": "✅ Conta criada! Sessão iniciada.",
    "login.msg.emailExists": "⚠️ Já existe uma conta com este email.",
    "login.msg.registerFail": "❌ Não foi possível criar a conta.",
    "login.msg.registerUnexpected": "❌ Erro inesperado ao criar conta.",
    "login.msg.loginSuccess": "✅ Sessão iniciada!",
    "login.msg.invalidCredentials": "❌ Email ou palavra-passe incorretos.",
    "login.msg.loginError": "❌ Erro ao iniciar sessão.",
    "setNewPassword.title": "Definir nova password",
    "setNewPassword.placeholder": "Nova password",
    "setNewPassword.button.updating": "A atualizar...",
    "setNewPassword.button.update": "Atualizar password",
    "setNewPassword.msg.tooShort":
      "❗ A password deve ter pelo menos 6 caracteres.",
    "setNewPassword.msg.success": "✅ Password atualizada com sucesso!",
    "setNewPassword.msg.invalidCode": "❌ Código inválido ou expirado.",
    "hud.latLon": "Lat/Lon",
    "hud.accuracy": "Precisão",
    "hud.speedFiltered": "Velocidade (filtrada)",
    "hud.raw": "RAW",
    "hud.historyPoints": "pts hist",
    "hud.altitude": "Altitude",
    "hud.gpsStatus": "Estado GPS",
    "chart.elevation.loading": "A preparar perfil de elevação…",
    "chart.elevation.noData": "Sem dados de elevação ainda.",
    "chart.stats.distance": "Distância:",
    "chart.stats.ascent": "Subida:",
    "chart.stats.descent": "Descida:",
    "trail.title": "Trilhos & Eventos Trekkin",
    "trail.license.itp": "Registada no ITP com a Licença: RNAAT Nº 1096/2023",
    "trail.license.icnf": "Reconhecido como Turismo de Natureza pelo ICNF.",
    "trail.section.trails": "Trilhos disponíveis",
    "trail.globalChat": "Chat Global",
    "trail.someone": "alguém",
    "trail.events.title": "Eventos Trekkin",
    "trail.noImage": "Sem imagem",
    "trail.dateTbd": "Data a definir",
    "trail.locationPrefix": "Local:",
    "trail.noEvents": "Nenhum evento disponível.",
    "trail.pastEvents": "Eventos passados",
    "trail.fallback.trail": "Trilho",
    "trail.fallback.event": "Evento",
    "trailItem.title.editName": "Editar nome",
    "trailItem.prompt.rename": "Novo nome do trilho:",
    "trailItem.toast.deleted": "🗑️ Trilho \"{name}\" eliminado.",
    "trailDetails.noTrailSelected": "Nenhum trilho selecionado.",
    "trailDetails.back": "Voltar",
    "trailDetails.noPermissionView":
      "🔒 O teu plano não permite ver os detalhes do trilho. Subscreve Explorer, Adventure ou Guide.",
    "trailDetails.noPermissionEdit": "❗ O teu plano não permite editar trilhos. Subscreve Explorer, Adventure ou Guide.",
    "trailDetails.cannotEdit": "Este trilho não pode ser editado.",
    "trailDetails.notEnoughPoints": "Sem pontos suficientes para editar.",
    "trailDetails.noPermissionDelete": "❗ O teu plano não permite apagar trilhos. Subscreve Explorer, Adventure ou Guide.",
    "trailDetails.confirmDelete": "Eliminar este trilho definitivamente?",
    "trailDetails.deleted": "🗑️ Trilho eliminado.",
    "trailDetails.noPermissionLinkEvent":
      "❗ O teu plano não permite criar ou associar eventos. Subscreve Explorer, Adventure ou Guide.",
    "trailDetails.coordsUnavailable": "Coordenadas não disponíveis.",
    "trailDetails.enterValidName": "Indica um nome válido.",
    "trailDetails.nameUpdated": "Nome do trilho atualizado.",
    "trailDetails.loadingTrail": "A carregar trilho...",
    "trailDetails.pointsLabel": "pontos",
    "trailDetails.primary": "Principal",
    "trailDetails.alternative": "Alternativo",
    "trailDetails.tour": "Tour",
    "trailDetails.day": "Dia",
    "trailDetails.action.edit": "Editar",
    "trailDetails.action.addToEvent": "Adicionar a Evento",
    "trailDetails.action.navigate": "Navegar",
    "trailDetails.action.delete": "Eliminar",
    "liveShare.title": "Partilha em tempo real",
    "liveShare.ended": "Partilha terminada — última posição visível.",
    "liveShare.noPermissionOpen": "❗ O teu plano não permite abrir Live Share. Subscreve Explorer, Adventure ou Guide.",
    "liveShare.noPositionYet": "⚠️ Sem posição ainda.",
    "liveShare.elevationProfile": "Perfil de Elevação",
    "liveShare.timeAgo.justNow": "agora mesmo",
    "liveShare.timeAgo.seconds": "{n}s atrás",
    "liveShare.timeAgo.minutes": "{n}m atrás",
    "liveShare.timeAgo.hours": "{n}h atrás",
    "intro.loading": "A inicializar a aplicação...",
    "nav.title": "Navegação",
    "nav.description": "Carrega um trilho GPX, segue um percurso ou grava livremente.",
    "nav.loadGpx": "Carregar\nGPX",
    "nav.record.start": "Gravar",
    "nav.record.stop": "Parar",
    "nav.record.pause": "Pausar",
    "nav.record.resume": "Retomar",
    "nav.record.finish": "Terminar",
    "nav.stats.time": "Tempo",
    "nav.stats.stopped": "Parado",
    "nav.stats.moving": "Andar",
    "nav.stats.average": "Média",
    "nav.stats.ascent": "Subida",
    "nav.stats.distance": "Distância",
    "nav.stats.altitude": "Altitude",
    "nav.stats.location": "Localização",
    "nav.chart.recording": "Gravação",
    "nav.chart.altimetry": "Altimetria",
    "nav.chart.heartRate": "Frequência cardíaca",
    "nav.heartRate.title": "FREQUÊNCIA CARDÍACA",
    "nav.heartRate.searching": "A procurar sensor…",
    "nav.heartRate.permissionDenied": "Permissão não concedida",
    "nav.heartRate.noSensor": "Sem sensor ligado",
    "nav.resume.nextDayPrompt":
      "A gravação \"{name}\" foi iniciada noutro dia. Queres continuar esta rota?\n\nOK: Continuar mesma rota\nCancelar: Começar nova rota",
    "nav.resume.farPrompt":
      "Estás longe do último ponto da gravação (~{distanceM} m). Queres continuar a mesma rota?\n\nOK: Continuar mesma rota\nCancelar: Começar nova rota",
    "nav.toast.autoPausedInactive": "⏸️ Gravação em pausa automática por inatividade.",
    "nav.toast.resumedRecording": "▶️ Gravação retomada.",
    "nav.toast.startedNewRecording": "✅ Nova gravação iniciada.",
    "nav.history": "Histórico",
    "nav.waypoints": "Waypoints",
    "nav.liveShare.start": "Partilhar",
    "nav.liveShare.stop": "Parar partilha",
    "nav.toast.historyDenied": "❗ O teu plano não permite ver o histórico. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.waypointsDenied": "❗ O teu plano não permite aceder a Waypoints. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.liveShareDenied": "❗ O teu plano não permite Live Share. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.startNavDenied": "❗ O teu plano não permite iniciar navegação. Subscreve Explorer, Adventure ou Guide.",
    "nav.waypoint.stop": "Parar navegação",
    "nav.waypoint.add": "Adicionar",
    "nav.waypoint.destination": "Destino: {name}",
    "nav.waypoint.queue": "{n} waypoint(s) em fila",
    "nav.waypoint.none": "Sem navegação ativa",
    "nav.toast.stopNavDenied": "❗ O teu plano não permite parar a navegação. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.navEnded": "Navegação terminada.",
    "nav.toast.createTrailsDenied": "❗ O teu plano não permite criar trilhos. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.planRoutesDenied": "❗ O teu plano não permite planear rotas. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.uploadGpxDenied": "❗ O teu plano não permite carregar trilhos GPX. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.trailUploaded": "✅ Trilho \"{name}\" carregado.",
    "nav.toast.trailUploadError": "❌ Erro ao carregar ficheiro GPX.",
    "nav.toast.liveEnded": "🛑 LIVE terminado.",
    "nav.toast.liveCreated": "🔗 LIVE criado!",
    "nav.toast.copyLinkSuccess": "📋 Link copiado!",
    "nav.toast.copyLinkManual": "⚠️ Copia manual acima.",
    "nav.toast.noTrailsLoaded": "Nenhum trilho carregado ainda.",
    "nav.toast.trailDisabled": "🛑 Trilho desativado.",
    "nav.toast.startLoadedTrailDenied":
      "❗ O teu plano não permite iniciar trilhos carregados. Subscreve Explorer, Adventure ou Guide.",
    "nav.toast.trailActive": "🧭 Trilho \"{name}\" ativo.",
    "nav.toast.trailNoValidPoints": "⚠️ Trilho sem pontos válidos.",
    "nav.bg.title": "Gravação em segundo plano",
    "nav.bg.body":
      "A Trekkin.pt precisa de aceder à tua localização mesmo com a app em segundo plano (ecrã bloqueado) para:",
    "nav.bg.bullet1": "Gravar o teu trilho com precisão",
    "nav.bg.bullet2": "Manter a navegação e métricas durante a caminhada",
    "nav.bg.bullet3":
      "(Opcional) Partilhar a tua posição com o teu grupo quando o modo LIVE estiver ativo",
    "nav.bg.note":
      "Podes desativar esta permissão a qualquer momento nas Definições do Android.",
    "nav.bg.skip": "Agora não",
    "nav.bg.continue": "Continuar",
    "nav.createTrail": "Criar trilho",
    "nav.createRoute": "Criar rota",
    "nav.draw.save": "Guardar trilho desenhado",
    "nav.draw.clear": "Limpar desenho",
    "nav.draw.defaultName": "Trilho desenhado",
    "nav.draw.notEnoughPoints": "Sem pontos suficientes.",
    "nav.draw.saveFailed": "Falha ao guardar trilho.",
    "nav.draw.saved": "Trilho guardado.",
    "nav.fallback.waypoint": "Waypoint",
    "nav.weather.nextHours": "Meteorologia · próximas 3 horas",
    "nav.weather.waitingLocation": "A aguardar localização para obter a previsão.",
    "navRealtime.title": "Monitorização em tempo real",
    "navRealtime.noGroup": "Ainda não tens nenhum grupo selecionado.",
    "navRealtime.subtitle": "Acompanhar o guia do grupo em tempo real (Firebase).",
    "navRealtime.status.connected": "Ligado ao grupo",
    "navRealtime.status.noData": "Sem dados em tempo real",
    "navRealtime.backToNav": "Voltar ao Nav",
    "history.title": "O Meu Histórico",
    "history.state.cloudActive": "Cloud ativa",
    "history.state.cloudDesc": "As gravações são sincronizadas automaticamente.",
    "history.state.localOnly": "Dados apenas locais",
    "history.state.localDesc": "As gravações ficam só neste dispositivo.",
    "history.empty": "Ainda não tens gravações.",
    "history.cloud.synced": "☁️ Sincronizado",
    "history.cloud.pending": "⏳ Pendente de sincronização",
    "history.cloud.local": "📍 Apenas local",
    "history.action.follow": "Seguir",
    "history.action.details": "Detalhes",
    "history.action.download": "Descarregar",
    "history.action.delete": "Eliminar",
    "history.action.shareImage": "Partilhar imagem da atividade",
    "history.recovery.action": "Recuperar gravação local",
    "history.progress.title": "Progresso",
    "history.progress.loading": "A atualizar o progresso…",
    "history.progress.years": "Anos",
    "history.progress.months": "Meses",
    "history.progress.weeks": "Semanas",
    "history.progress.period": "Período das estatísticas: {period}",
    "history.progress.distance": "Distância",
    "history.progress.accumulated": "Acumulado",
    "history.progress.accumulatedDPlus": "Acumulado D+",
    "history.progress.windowWeeks": "Janela de {count} semanas",
    "history.progress.windowMonths": "Janela de {count} meses",
    "history.progress.windowYears": "Janela de {count} anos",
    "history.alert.deleteDenied": "❗ O teu plano não permite apagar gravações. Subscreve Explorer, Adventure ou Guide.",
    "history.confirm.delete": "Eliminar esta gravação definitivamente?",
    "history.alert.downloadDenied": "❗ O teu plano não permite descarregar GPX. Subscreve Explorer, Adventure ou Guide.",
    "history.alert.insufficientData": "Este trilho não tem dados suficientes.",
    "history.alert.androidFilesystemUnavailable": "Android: plugin Filesystem não disponível.",
    "history.alert.androidWriteFail": "Android: falha ao gravar GPX.",
    "history.alert.androidShareUnavailable": "Android: plugin Share/Browser não disponível.",
    "history.alert.exportNavDenied": "❗ O teu plano não permite exportar para a rede. Subscreve Explorer, Adventure ou Guide.",
    "history.confirm.exportNav": "Adicionar este trilho à rede de navegação?",
    "history.toast.noValidPoints": "Trilho sem pontos válidos.",
    "history.toast.tooFewPointsAfterDedup": "Poucos pontos após remover duplicados.",
    "history.toast.addedToNavGrid": "Trilho adicionado à rede.",
    "history.alert.followDenied": "❗ O teu plano não permite seguir trilhos. Subscreve Explorer, Adventure ou Guide.",
    "history.alert.noValidPoints": "Este trilho não tem pontos válidos.",
    "eventList.toast.invalidTrail": "Trilho inválido.",
    "eventList.emptyUpcoming.title": "Novas aventuras estão a caminho!",
    "eventList.emptyUpcoming.body": "Estamos a preparar novos eventos e a melhorar a experiência na app. Volta em breve — há mais trilhos para descobrir!",
    "eventList.toast.primaryTrailDenied": "❗ O teu plano não permite definir o trilho principal. Subscreve Explorer, Adventure ou Guide.",
    "eventList.toast.altTrailDenied": "❗ O teu plano não permite adicionar trilhos alternativos. Subscreve Explorer, Adventure ou Guide.",
    "eventList.toast.noGpxAvailable": "Sem GPX disponível para o trilho.",
    "eventList.toast.invalidGpx": "GPX inválido.",
    "eventList.toast.primaryUpdated": "✅ Trilho principal atualizado.",
    "eventList.toast.altAdded": "✅ Trilho alternativo adicionado ao evento.",
    "eventList.toast.tourAdded": "✅ Rota tour adicionada ao evento.",
    "eventList.toast.noMeetingPoints": "Este evento não tem trilhos por dia disponíveis.",
    "eventList.prompt.pickDay": "Escolhe o dia para associar o trilho (número):",
    "eventList.toast.invalidDay": "Dia inválido.",
    "eventList.toast.dayUpdated": "✅ Trilho atualizado no Dia {day}.",
    "eventList.toast.addTrailError": "❌ Erro ao adicionar trilho ao evento.",
    "eventDetails.title": "Detalhes do evento",
    "eventDetails.state.invalid": "Evento inválido ou não encontrado.",
    "eventDetails.state.loading": "A carregar evento…",
    "eventDetails.fallback.guideName": "Guia do evento",
    "eventDetails.fallback.lodgingName": "Alojamento do evento",
    "eventDetails.toast.cannotOpenNavigation": "Não foi possível abrir a navegação.",
    "eventDetails.toast.loadingTryAgain": "Evento ainda a carregar. Tenta novamente.",
    "eventDetails.toast.noPermissionContactGuide": "Não tens permissão para contactar o guia.",
    "eventDetails.toast.loginRequiredContactGuide": "É necessário login para contactar o guia.",
    "eventDetails.toast.guideNotFound": "Guia não encontrado.",
    "eventDetails.toast.cannotOpenChat": "Não foi possível abrir o chat com o guia.",
    "eventDetails.toast.alreadyRegistered": "Já estás inscrito neste evento.",
    "eventDetails.toast.cannotOpenVideo": "Não foi possível abrir o vídeo.",
    "eventDetails.access.inviteOnlyTitle": "Evento apenas para convidados",
    "eventDetails.access.privateTitle": "Evento privado",
    "eventDetails.access.inviteOnlyLine1": "Evento apenas para utilizadores convidados!",
    "eventDetails.access.inviteOnlyLine2": "Para mais informações contacte o guia do evento.",
    "eventDetails.access.requestInvite": "Pedir convite",
    "eventDetails.access.requestAgain": "Pedir convite novamente",
    "eventDetails.access.requestSending": "A enviar…",
    "eventDetails.access.requestPendingShort": "Pedido de convite pendente.",
    "eventDetails.access.requestPending": "Pedido de convite pendente de decisão do guia.",
    "eventDetails.access.requestRejected": "O pedido anterior não foi aceite.",
    "eventDetails.access.privateBody":
      "Este evento não é público ou ainda não foi publicado. Apenas o guia ou administradores podem aceder.",
    "eventDetails.access.contactGuide": "Contactar o Guia ({name})",
    "eventDetails.header.fallbackName": "Evento Trekkin",
    "guide.actions.whatsappGroup": "Entrar na comunidade Trekkin",
    "guide.actions.whatsappCommunityHint": "Novidades, partilhas e aventuras no WhatsApp",
    "guide.newsletter.title": "Novidades Trekkin no teu email",
    "guide.newsletter.description": "Descobre novos trilhos, eventos e aventuras em primeira mão.",
    "guide.newsletter.subscribe": "Subscrever newsletter",
    "eventDetails.header.badge": "Evento Trekkin",
    "eventDetails.unit.day": "dia",
    "eventDetails.unit.days": "dias",
    "eventDetails.overview.distance": "distância total",
    "eventDetails.overview.ascent": "desnível positivo",
    "eventDetails.overview.price": "preço do evento",
    "eventDetails.registration.enroll": "Inscrever-me",
    "eventDetails.registration.chooseDays": "Escolher dias e inscrever",
    "eventDetails.registration.multiDayLabel": "Participa em 1 ou mais dias",
    "eventDetails.registration.byDayTitle": "Inscrição por dia disponível",
    "eventDetails.registration.byDayBody": "Podes participar no evento completo ou selecionar apenas os dias pretendidos.",
    "eventDetails.registration.byDayBadge": "Evento completo ou por dia",
    "eventDetails.registration.fullPrice": "Evento completo",
    "eventDetails.registration.dayPriceFrom": "Um dia desde",
    "eventDetails.registration.extrasNote": "O total é atualizado com os dias escolhidos e extras como alojamento, refeições ou transfer.",
    "eventDetails.registration.pendingShort": "Inscrição pendente",
    "eventDetails.transfer.fromPrice": "Transfer desde {price} €",
    "eventDetails.transfer.available": "Transfer disponível",
    "eventDetails.cancellation.title": "Política de cancelamento",
    "eventDetails.shortcuts.gallery": "Galeria",
    "eventDetails.shortcuts.trails": "Trilhos",
    "eventDetails.shortcuts.lodging": "Alojamento",
    "eventDetails.shortcuts.share": "Partilhar",
    "eventDetails.capture.button": "Criar imagem completa do evento",
    "eventDetails.capture.working": "A criar imagem…",
    "eventDetails.capture.preparing": "A preparar a imagem completa do evento…",
    "eventDetails.capture.shareTitle": "Partilhar imagem do evento",
    "eventDetails.capture.saved": "Imagem do evento guardada.",
    "eventDetails.capture.error": "Não foi possível criar a imagem completa do evento.",
    "eventDetails.actions.edit": "Editar evento",
    "eventDetails.shortcuts.openSharedEvent": "Vê os detalhes e inscreve-te:",
    "eventDetails.general.title": "Informações gerais",
    "eventDetails.general.startDate": "Data de início",
    "eventDetails.general.duration": "Duração",
    "eventDetails.general.price": "Preço",
    "eventDetails.general.tbd": "A definir",
    "eventDetails.general.transferOptional": "Transfer (opcional)",
    "eventDetails.meals.globalTitle": "Refeições globais",
    "eventDetails.action.hide": "Ocultar",
    "eventDetails.action.view": "Ver",
    "eventDetails.info.dateTime": "Data e hora",
    "eventDetails.info.dateTbd": "Data a definir",
    "eventDetails.info.price": "Preço do evento",
    "eventDetails.info.free": "Gratuito",
    "eventDetails.info.slots": "Vagas",
    "eventDetails.info.available": "Disponíveis",
    "eventDetails.info.availableYes": "Sim",
    "eventDetails.info.soldOut": "Esgotado",
    "eventDetails.info.noLimit": "Sem limite definido",
    "eventDetails.transfer.title": "Transfer",
    "eventDetails.transfer.price": "Preço",
    "eventDetails.transfer.noPrice": "Sem preço definido",
    "eventDetails.transfer.seats": "Lugares",
    "eventDetails.transfer.time": "Hora",
    "eventDetails.transfer.startPoint": "Ponto de início do transfer",
    "eventDetails.meetingPoint.title": "Ponto de encontro do evento",
    "eventDetails.publish.onlyVisible":
      "Este evento ainda não está publicado. Apenas visível para o guia, administrador e parceiros associados.",
    "eventDetails.guide.title": "Guia",
    "eventDetails.guide.avatarAlt": "Guia",
    "eventDetails.guide.responsible": "Guia responsável",
    "eventDetails.guide.contactTitle": "Enviar mensagem ao guia",
    "eventDetails.coGuide.title": "Co-guia",
    "eventDetails.coGuide.avatarAlt": "Co-guia",
    "eventDetails.coGuide.fallbackName": "Co-guia",
    "eventDetails.coGuide.responsible": "Co-guia responsável",
    "eventDetails.coGuide.contactTitle": "Enviar mensagem ao co-guia",
    "eventDetails.registration.title": "Inscrições",
    "eventDetails.registration.cta": "Fazer inscrição e ver opções disponíveis!",
    "eventDetails.registration.pending": "Inscrição efetuada. Aguarda confirmação.",
    "eventDetails.registration.confirmed": "Inscrição confirmada.",
    "eventDetails.gallery.title": "Galeria do evento",
    "eventDetails.gallery.thumbAlt": "Galeria evento",
    "eventDetails.gallery.fullAlt": "Imagem evento",
    "eventDetails.teaser.title": "Teaser do evento",
    "eventDetails.teaser.subtitle": "Vídeo de apresentação preparado pelo guia.",
    "eventDetails.summary.title": "Resumo do evento",
    "eventDetails.altimetry.title": "Altimetria e traçado global",
    "eventDetails.altimetry.distance": "Distância",
    "eventDetails.altimetry.noGpx": "Nenhum GPX global definido para este evento.",
    "eventDetails.altimetry.preparing": "A preparar perfil de elevação…",
    "eventDetails.days.title": "Dias e pontos de encontro",
    "eventDetails.days.empty": "Este evento não tem dias adicionais configurados.",
    "eventDetails.included.title": "Incluído no evento",
    "eventDetails.shouldBring.title": "Deve levar",
    "eventDetails.technicalDetails.title": "Detalhes técnicos",
    "eventDetails.longDescription.title": "Detalhes completos",
    "eventDetails.error.weather": "Não foi possível obter a previsão meteorológica.",
    "eventDetails.error.altimetry": "Não foi possível calcular a altimetria.",
    "eventDetails.weather.title": "Previsão meteorológica",
    "eventDetails.weather.loading": "A carregar previsão…",
    "eventDetails.weather.na": "n/d",
    "eventDetails.weather.precipProb": "Prob. precipitação",
    "eventDetails.weather.wind": "Vento",
    "eventDetails.weather.notAvailableAccurate":
      "Previsão não disponível (a data do evento é demasiado distante).",
    "eventDetails.weather.notAvailable": "Previsão não disponível.",
    "eventDetails.weather.condition.clear": "Céu limpo",
    "eventDetails.weather.condition.partlyCloudy": "Parcialmente nublado",
    "eventDetails.weather.condition.fog": "Nevoeiro",
    "eventDetails.weather.condition.drizzle": "Chuviscos",
    "eventDetails.weather.condition.rain": "Chuva",
    "eventDetails.weather.condition.freezingRain": "Chuva gelada",
    "eventDetails.weather.condition.snow": "Neve",
    "eventDetails.weather.condition.showers": "Aguaceiros",
    "eventDetails.weather.condition.snowShowers": "Aguaceiros de neve",
    "eventDetails.weather.condition.thunderstorm": "Trovoada",
    "eventDetails.weather.condition.notAvailable": "Não disponível",
    "eventDetails.lodging.globalTitle": "Alojamento global",
    "eventDetails.lodging.lodging": "Alojamento",
    "eventDetails.lodging.camping": "Acampamento",
    "eventDetails.lodging.price.free": "Grátis",
    "eventDetails.lodging.price.included": "Incluído",
    "eventDetails.lodging.note":
      "Nota: valores por pessoa/noite (quando aplicável). A escolha do alojamento é feita na inscrição.",
    "eventDay.day": "Dia {n}",
    "eventDay.distance": "Distância do dia",
    "eventDay.meetingPoint": "Ponto de encontro",
    "eventDay.notDefined": "Ainda não definido",
    "eventDay.weather": "Meteorologia",
    "eventDay.lodging.title": "Alojamento",
    "eventDay.lodging.fallbackName": "Alojamento",
    "eventDay.price.free": "Grátis",
    "eventDay.price.included": "Incluído",
    "eventDay.price.perPerson": "{price} por pessoa",
    "eventDay.price.wholeProperty": "{price} pela casa",
    "eventDay.price.capacity": "{count} pessoas",
    "eventDay.inventory.doubleBed": "{count} cama de casal",
    "eventDay.inventory.doubleBeds": "{count} camas de casal",
    "eventDay.inventory.singleBed": "{count} cama individual",
    "eventDay.inventory.singleBeds": "{count} camas individuais",
    "eventDay.inventory.capacity": "capacidade {count} pessoas",
    "eventDay.price.doubleRoom": "Cama de casal: {price}",
    "eventDay.price.singleRoom": "Cama individual: {price}",
    "eventDay.price.perRoom": "{price} por quarto",
    "eventDay.price.twoPersonTent": "Tenda 2 pessoas: +{price}",
    "eventDay.price.onePersonTent": "Tenda individual: +{price}",
    "eventDay.meals.title": "Refeições do dia",
    "eventDay.meals.fallbackName": "Refeição",
    "eventDay.route.title": "Percurso do dia",
    "eventDay.elevation.min": "Alt. mín.",
    "eventDay.elevation.max": "Alt. máx.",
    "eventRegister.state.notFound": "Evento não encontrado.",
    "eventRegister.title": "Inscrição no evento",
    "eventRegister.subtitle": "Preenche os dados e confirma a tua inscrição.",
    "eventRegister.participants.title": "Participantes",
    "eventRegister.participants.subtitle":
      "Podes adicionar mais pessoas à tua inscrição.",
    "eventRegister.participants.add": "Adicionar participante",
    "eventRegister.participants.nameLabel": "Nome (opcional)",
    "eventRegister.participants.emailLabel": "Email",
    "eventRegister.participants.remove": "Remover",
    "eventRegister.participants.sameOptions": "Mesmas opções para todos",
    "eventRegister.participants.editOptions": "Editar opções de",
    "eventRegister.participants.ownerLabel": "Eu (titular)",
    "eventRegister.participants.inviteeLabel": "Convidado {n}",
    "eventRegister.participants.editing": "A editar opções de",
    "eventRegister.participants.invalidEmail":
      "Indica emails válidos para os participantes.",
    "eventRegister.participants.duplicateEmail":
      "Existem emails duplicados na lista de participantes.",
    "eventRegister.participants.ownerEmailConflict":
      "Não podes adicionar o teu próprio email como convidado.",
    "eventRegister.required.title": "Dados obrigatórios",
    "eventRegister.required.ccLabel": "Número de CC",
    "eventRegister.required.ccPlaceholder": "Número do Cartão de Cidadão",
    "eventRegister.required.dobLabel": "Data de nascimento",
    "eventRegister.participation.title": "Participação",
    "eventRegister.participation.fullEvent": "Evento completo",
    "eventRegister.participation.selectDays": "Selecionar dias",
    "eventRegister.participation.day": "Dia {n}",
    "eventRegister.transfer.fullEventOnly": "O transfer está disponível apenas na inscrição para o evento completo.",
    "eventRegister.validation.selectAtLeastOneDay": "Seleciona pelo menos um dia.",
    "eventRegister.error.ccRequired": "Indica o número de CC.",
    "eventRegister.error.dobRequired": "Indica a data de nascimento.",
    "eventRegister.toast.submitted": "✅ Inscrição submetida!",
    "eventRegister.toast.error": "❌ Erro ao submeter inscrição.",
    "eventRegister.lodging.infoTitle": "Alojamento",
    "eventRegister.lodging.infoGlobal":
      "Este evento tem alojamento global (aplica-se a todos os dias).",
    "eventRegister.lodging.infoPerDay": "Este evento tem opções de alojamento por dia.",
    "eventRegister.lodging.lodging": "Alojamento",
    "eventRegister.lodging.camping": "Acampamento",
    "eventRegister.lodging.globalTitleFull": "Alojamento global (evento completo)",
    "eventRegister.lodging.globalTitleSelected": "Alojamento global (dias selecionados)",
    "eventRegister.lodging.globalTitle": "Alojamento global",
    "eventRegister.lodging.globalNone": "Sem alojamento global",
    "eventRegister.lodging.price.free": "Grátis",
    "eventRegister.lodging.price.included": "Incluído",
    "eventRegister.lodging.lodgingFallback": "Alojamento",
    "eventRegister.lodging.perDayTitleFull": "Alojamento por dia (evento completo)",
    "eventRegister.lodging.perDayTitleSelected": "Alojamento por dia (dias selecionados)",
    "eventRegister.lodging.selectDaysForOptions": "Seleciona dias para ver as opções.",
    "eventRegister.lodging.noneThisDay": "Sem alojamento neste dia",
    "eventRegister.lodging.thisDayTitle": "Alojamento deste dia",
    "eventRegister.lodging.none": "Sem alojamento",
    "eventRegister.lodging.tentSummary": "Tendas: {two} de 2 pessoas · {one} de 1 pessoa",
    "eventRegister.lodging.perPerson": "Preço por pessoa",
    "eventRegister.lodging.participantOnly": "Esta escolha aplica-se apenas a este participante.",
    "eventRegister.transfer.title": "Transfer",
    "eventRegister.transfer.add": "Adicionar transfer",
    "eventRegister.breakdown.title": "Resumo da inscrição",
    "eventRegister.breakdown.fullEvent": "Evento completo",
    "eventRegister.breakdown.participationDays": "Participação (dias)",
    "eventRegister.breakdown.transfer": "Transfer",
    "eventRegister.breakdown.globalLodging": "Alojamento global",
    "eventRegister.breakdown.dayLodging": "Alojamento (dias)",
    "eventRegister.breakdown.lodging": "Alojamento",
    "eventRegister.breakdown.total": "Total",
    "eventRegister.singleDay.title": "Participação",
    "eventRegister.singleDay.price": "Preço",
    "eventRegister.payment.title": "Pagamento",
    "eventRegister.payment.split": "Cada participante paga o seu",
    "eventRegister.payment.splitHint":
      "Cada participante recebe o seu email de pagamento.",
    "eventRegister.payment.single": "Pagamento único (titular)",
    "eventRegister.payment.singleHint": "O titular paga o total por todos.",
    "eventRegister.payment.groupTotal": "Total do grupo",
    "eventRegister.action.submitting": "A submeter…",
    "eventRegister.action.confirm": "Confirmar inscrição",
    "eventEnroll.loading": "A carregar…",
    "eventEnroll.notFound": "Inscrição não encontrada.",
    "eventEnroll.title": "Inscrição recebida",
    "eventEnroll.subtitle": "Recebemos a tua inscrição para",
    "eventEnroll.price.included": "Incluído",
    "eventEnroll.participation.title": "Participação",
    "eventEnroll.participation.fullEvent": "Evento completo",
    "eventEnroll.participation.day": "Dia {n}",
    "eventEnroll.transfer.title": "Transfer",
    "eventEnroll.lodging.title": "Alojamento",
    "eventEnroll.lodging.globalPrefix": "Alojamento global",
    "eventEnroll.lodging.none": "Sem alojamento selecionado.",
    "eventEnroll.payment.title": "Pagamento",
    "eventEnroll.payment.body1":
      "O pagamento é tratado por email. Vais receber instruções para concluir a inscrição.",
    "eventEnroll.payment.body2":
      "Se não receberes o email, verifica a pasta de spam ou contacta-nos.",
    "eventEnroll.payment.groupOwner": "O titular paga o total do grupo.",
    "eventEnroll.total.title": "Total",
    "eventEnroll.total.groupTitle": "Total do grupo",
  },
  en: {
    "common.user": "User",
    "common.event": "Event",
    "common.unknown": "Unknown",
    "common.confirm": "Confirm",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "settings.title": "Settings",
    "settings.account.title": "Account",
    "settings.account.sessionActiveAs": "Signed in as:",
    "settings.account.updateProfile": "Update profile",
    "settings.account.manageSubscription": "Manage subscription",
    "settings.account.signOut": "Sign out",
    "settings.account.signingOut": "Signing out…",
    "settings.account.noSession": "Not signed in.",
    "settings.account.signIn": "Sign in",
    "settings.wallet.title": "Wallet",
    "settings.wallet.description": "Add funds for upcoming event registrations or save them for a future adventure.",
    "settings.wallet.sending": "Sending email...",
    "settings.wallet.paymentLink": "Receive payment link by email",
    "settings.wallet.coupons": "View coupons",
    "settings.heartRate.title": "Heart rate",
    "settings.heartRate.description": "Choose the source used while recording. Automatic connects to the first compatible source available.",
    "settings.heartRate.preferredSource": "Preferred source",
    "settings.heartRate.auto": "Automatic (recommended)",
    "settings.heartRate.authorizeAppleHealth": "Authorize Apple Health",
    "settings.maps.title": "Maps",
    "settings.maps.subtitle": "Base map used in the app.",
    "settings.maps.cacheNote":
      "Maps are stored on the device and cleared after {ttl} without use.",
    "settings.maps.lite": "Lite map PT",
    "settings.maps.pro": "Pro map PT",
    "settings.maps.download": "Download",
    "settings.maps.downloading": "Downloading",
    "settings.maps.noPermission": "No permission",
    "settings.maps.downloaded": "Downloaded",
    "settings.maps.source": "Source",
    "settings.maps.source.auto": "Automatic",
    "settings.maps.source.local": "Downloaded",
    "settings.maps.source.remote": "Online",
    "settings.maps.source.activeLocal": "In use: downloaded map",
    "settings.maps.source.activeRemote": "In use: cache and online map",
    "settings.maps.clearMaps": "Clear maps",
    "settings.maps.clearing": "Clearing",
    "settings.maps.confirmDelete": "Delete downloaded maps?",
    "settings.maps.adminOnly": "Management/admin only.",
    "settings.maps.contours": "Contours",
    "settings.maps.missing": "missing",
    "settings.maps.clearCache": "Clear cache",
    "settings.support.title": "Help and support",
    "settings.support.description": "Found a problem? Send us a description and, if possible, images.",
    "settings.support.report": "Report a problem",
    "settings.support.myReports": "My reports",
    "myReports.title": "My reports",
    "myReports.subtitle": "Track the problems you submitted and their status.",
    "myReports.empty": "You have not submitted any reports yet.",
    "myReports.status.pending": "Submitted",
    "myReports.status.in_progress": "Under review",
    "myReports.status.validation": "Awaiting validation",
    "myReports.status.resolved": "Resolved",
    "myReports.status.dismissed": "Closed",
    "myReports.adminNote": "Team response",
    "myReports.comment": "Comment",
    "myReports.commentPlaceholder": "Add a note about the fix or explain what is still happening…",
    "myReports.confirm": "Confirm fix",
    "myReports.reopen": "Reopen report",
    "issueReport.title": "Report a problem",
    "issueReport.subtitle": "Help us understand and fix the problem.",
    "issueReport.problem": "Problem",
    "issueReport.category": "Category",
    "issueReport.category.bug": "Error / bug",
    "issueReport.category.gps": "GPS / recording",
    "issueReport.category.maps": "Maps / navigation",
    "issueReport.category.account": "Account / payments",
    "issueReport.category.suggestion": "Suggestion",
    "issueReport.category.other": "Other",
    "issueReport.description": "What happened?",
    "issueReport.descriptionPlaceholder": "Tell us what you were doing, what you expected to happen and what happened...",
    "issueReport.images": "Images",
    "issueReport.imagesHint": "(optional, maximum {max})",
    "issueReport.addImage": "Add image",
    "issueReport.technicalInfo": "The app version, platform and technical device information will be included automatically. GPS location data is not sent.",
    "issueReport.submitting": "Submitting...",
    "issueReport.submit": "Submit",
    "settings.maps.toast.noPermissionDownloadLite":
      "❗ You don't have permission to download the Lite map. Subscribe to Explorer, Adventure or Guide.",
    "settings.maps.toast.noPermissionDownloadPro":
      "❗ You don't have permission to download the Pro map. Subscribe to Explorer, Adventure or Guide.",
    "settings.maps.toast.downloadUnavailable": "Download unavailable on this device.",
    "settings.maps.toast.liteAlreadyDownloaded": "Lite map already downloaded.",
    "settings.maps.toast.proAlreadyDownloaded": "Pro map already downloaded.",
    "settings.maps.toast.downloadFailed": "Failed to download map.",
    "settings.maps.toast.liteDownloaded": "Lite map downloaded.",
    "settings.maps.toast.proDownloaded": "Pro map downloaded.",
    "settings.maps.toast.mapsRemoved": "Maps removed from memory.",
    "settings.maps.toast.clearFailed": "Failed to clear maps.",
    "settings.maps.toast.localUnavailable":
      "Download the selected map before using this mode.",
    "settings.maps.toast.noPermissionUseLite":
      "❗ You don't have permission to use the Lite map. Subscribe to Explorer, Adventure or Guide.",
    "settings.maps.toast.noPermissionUsePro":
      "❗ You don't have permission to use the Pro map. Subscribe to Explorer, Adventure or Guide.",
    "settings.alerts.title": "Alerts",
    "settings.alerts.chatMessages": "Group and direct message alerts",
    "settings.alerts.offTrail": "Enable off-trail alert",
    "settings.alerts.offTrailThreshold": "Alert distance",
    "settings.alerts.proximity": "Proximity alerts",
    "settings.alerts.fauna": "Fauna alerts",
    "settings.alerts.trail": "Trail alerts",
    "settings.alerts.security": "Security alerts",
    "settings.alerts.feedbackMode": "Alert mode",
    "settings.alerts.feedback.both": "Sound + vibration",
    "settings.alerts.feedback.vibrate": "Vibration only",
    "settings.alerts.feedback.sound": "Sound only",
    "settings.alerts.vibrate": "Vibrate alerts",
    "settings.alerts.sound": "Alert sounds",
    "settings.alerts.critical": "Critical alerts",
    "settings.push.description":
      "If notifications stopped arriving, authorize this device again and renew its delivery token.",
    "settings.push.reactivate": "Reactivate push notifications",
    "settings.push.reactivating": "Reactivating…",
    "settings.push.reactivated": "Push notifications reactivated on this device.",
    "settings.push.permissionDenied":
      "Notifications are blocked. Enable them in your device or browser settings and try again.",
    "settings.push.failed": "Push notifications could not be reactivated.",
    "settings.build.dev": "— dev build —",
    "bars.navigate": "Navigate",
    "bars.events": "Events",
    "bars.guides": "Guides",
    "bars.account": "Account",
    "bars.admin": "Admin",
    "topBar.show": "Show",
    "topBar.hide": "Hide",
    "topBar.compass": "Compass",
    "topBar.help": "Help",
    "topBar.chat": "Chat",
    "topBar.center": "Center",
    "topBar.network": "Network",
    "topBar.points": "Points",
    "topBar.alerts": "Alerts",
    "topBar.clear": "Clear",
    "topBar.clearTrails": "Clear trails from map",
    "nav.recording.activity": "Activity",
    "nav.recording.walk": "Hiking",
    "nav.recording.bike": "Cycling",
    "nav.recording.mode": "Mode",
    "nav.recording.normal": "Normal",
    "nav.recording.expedition": "Expedition",
    "nav.recording.precision": "Precision",
    "nav.recording.balanced": "Balanced",
    "nav.recording.battery": "Battery saver",
    "nav.recording.expeditionDescription": "While recording, Live Share, live events and remote telemetry are disabled. Normal sync resumes when you finish.",
    "nav.recording.normalDescription": "Full mode with sync and remote features enabled.",
    "nav.recording.locked": "The mode stays locked until you finish this recording.",
    "nav.stopConfirm.title": "Finish recording",
    "nav.stopConfirm.text": "Do you want to finish and save this recording?",
    "nav.stopConfirm.action": "Finish",
    "nav.availableTrails": "View available trails",
    "nav.missions": "Missions and Rewards",
    "nav.showTrailsMap": "Show trails on map",
    "nav.hideTrailsMap": "Hide trails from map",
    "guide.ratings.noPublicScore": "No public rating",
    "guide.ratings.latest": "Latest reviews",
    "guide.ratings.confirmHint": "Confirm new reviews after reading them.",
    "guide.ratings.newSingle": "new review",
    "guide.ratings.newPlural": "new reviews",
    "guide.ratings.noneNew": "You have no new reviews.",
    "guide.featured.title": "Most popular",
    "guide.title": "Guides & Groups",
    "guide.availableGuides.title": "Guides available to create adventures and private groups.",
    "guide.actions.chat": "Chat",
    "guide.actions.about": "About",
    "guide.about.title": "About the guide",
    "guide.about.empty": "This guide has not added a description yet.",
    "guide.about.close": "Close",
    "guide.description.autoSync":
      "Groups are now automatically synced by events. Join an event and your group will update without manual steps.",
    "guide.direct.empty": "— No direct contacts —",
    "guide.direct.label": "Direct chat",
    "guide.globalChat.title": "Global chat",
    "guide.globalChat.subtitle.noneYet": "— No messages yet —",
    "guide.globalChat.subtitle.newMessages": "— New messages —",
    "guide.globalChat.subtitle.noNewMessages": "— No new messages —",
    "guide.createGroup.title": "Create new group",
    "guide.createGroup.placeholder": "Group name",
    "guide.groups.title": "All groups",
    "guide.groups.empty": "You don't have groups yet.",
    "guide.groups.upcoming": "Upcoming events",
    "guide.groups.past": "Past events",
    "guide.note.autoParticipation":
      "Your participation is set automatically by the events you join.",
    "guide.online.title": "Online Guide",
    "guide.online.subtitle": "Private guided sessions requested by users.",
    "guide.online.requestButton": "Submit request",
    "guide.trailProposal.submit": "Submit request",
    "guide.trailProposal.title": "Custom trail proposal",
    "guide.trailProposal.subtitle": "Private events with an on-site guide, tailored to you.",
    "guide.partnerAccommodation.title": "Partner accommodation",
    "guide.partnerAccommodation.item": "Partner accommodation",
    "guide.partnerAccommodation.view": "View",
    "guide.bicycleAssistance.title": "Bicycle assistance and rental",
    "guide.bicycleAssistance.item": "Bicycle assistance and rental",
    "guide.bicycleAssistance.view": "View",
    "guide.pending.onlineTitle": "Pending requests — Online Guide",
    "guide.pending.trailTitle": "Pending requests — Trail proposal",
    "guide.online.pricing.insurance": "Insurance per person",
    "guide.online.pricing.hour": "Price per hour/person",
    "guide.online.form.title": "Online Guide Request",
    "guide.online.form.subtitle": "Fill the details to submit the request.",
    "guide.online.form.name": "Full name",
    "guide.online.form.email": "Email",
    "guide.online.form.phone": "Phone",
    "guide.online.form.peopleCount": "People count",
    "guide.online.form.requestedHours": "Requested hours",
    "guide.online.form.startTime": "Start date and time",
    "guide.online.form.meetingPoint": "Meeting point",
    "guide.online.form.pickPoint": "Pick on map",
    "guide.online.form.selectedPoint": "Selected:",
    "guide.online.form.routeDescription": "Route description",
    "guide.online.form.guestEmails": "Participant emails",
    "guide.online.form.guestEmailsHint": "e.g. anna@email.com, john@email.com",
    "guide.online.form.includeInsurance": "Include insurance",
    "guide.online.form.estimate": "Estimate",
    "guide.online.form.estimateNote":
      "Estimated value before submission. Payment is only requested after acceptance.",
    "guide.online.form.submit": "Submit request",
    "guide.online.form.submitting": "Submitting…",
    "guide.online.myRequests": "My requests",
    "guide.online.pending.title": "Pending requests",
    "guide.online.pending.empty": "No pending requests.",
    "guide.online.pending.accept": "Accept",
    "guide.online.pending.reject": "Reject",
    "guide.online.status.pending": "Pending",
    "guide.online.status.accepted": "Accepted",
    "guide.online.status.rejected": "Rejected",
    "guide.online.status.placeFallback": "Selected point",
    "guide.online.labels.people": "people",
    "guide.online.labels.hours": "hours",
    "guide.online.toast.authRequired": "You need to be logged in to request a guide.",
    "guide.online.toast.pointSelected": "Point selected.",
    "guide.online.toast.missingFields": "Fill all required fields.",
    "guide.online.toast.sent": "Request sent. You'll receive confirmation after acceptance.",
    "guide.online.toast.error": "Failed to send request.",
    "guide.online.delete.confirm": "Delete this request?",
    "guide.online.delete.confirmAccepted":
      "Delete this request and remove the related group and event?",
    "guide.online.delete.toast.success": "Request deleted.",
    "guide.online.delete.toast.error": "Failed to delete request.",
    "guide.online.delete.notAllowed":
      "You don't have permission to delete an accepted request. Subscribe to Explorer, Adventure or Guide.",
    "guide.online.payment.pay": "Pay",
    "guide.online.payment.paid": "Paid",
    "guide.online.payment.free": "Free",
    "guide.online.payment.loading": "Opening…",
    "guide.online.payment.toast.error": "Failed to create payment.",
    "guide.online.payment.toast.noApi": "Payment API unavailable.",
    "guide.online.accept.title": "Accept request",
    "guide.online.accept.hours": "Billable hours",
    "guide.online.accept.pricePerHour": "Price per hour/person",
    "guide.online.accept.insurancePerPerson": "Insurance per person",
    "guide.online.accept.offer": "Offer session (no payment)",
    "guide.online.accept.total": "Total",
    "guide.online.accept.confirm": "Confirm",
    "guide.online.accept.saving": "Saving…",
    "guide.online.accept.toast.success": "Request accepted successfully.",
    "guide.online.accept.toast.error": "Failed to accept request.",
    "guide.online.details.title": "Request details",
    "guide.online.details.none": "—",
    "guide.online.details.insuranceIncluded": "Insurance included",
    "guide.online.details.insuranceExcluded": "No insurance",
    "guide.online.reject.title": "Reject request",
    "guide.online.reject.reason": "Rejection reason",
    "guide.online.reject.placeholder": "Describe the reason for the user.",
    "guide.online.reject.confirm": "Reject",
    "guide.online.reject.saving": "Rejecting…",
    "guide.online.reject.toast.success": "Request rejected successfully.",
    "guide.online.reject.toast.error": "Failed to reject request.",
    "guide.online.reject.toast.missingReason": "Please provide a reason to reject.",
    "guide.online.reject.reasonLabel": "Reason",
    "guide.online.group.namePrefix": "Online Guide -",
    "guide.online.group.placeFallback": "Selected point",
    "guide.online.event.namePrefix": "Online Guide",
    "guide.group.ownerLabel": "Guide:",
    "guide.group.descriptionFallback": "No description set.",
    "guide.group.status.member": "You're a member — you can enter the chat.",
    "guide.group.status.visible": "Group visible — the event will handle your entry.",
    "guide.confirm.deleteGroup": "Delete group \"{name}\"?",
    "directChat.alert.planNotAllowed": "❗ Your plan doesn't allow direct chat.",
    "settings.appearance": "Appearance",
    "settings.language": "Language",
    "settings.theme.system": "System",
    "settings.theme.light": "Light",
    "settings.theme.dark": "Dark",
    "profile.title": "Trekkin Profile",
    "profile.noUser": "No authenticated user.",
    "profile.accountSection": "Trekkin Account",
    "profile.displayNameFallback": "Unnamed trekker",
    "profile.requiredData": "Required data for guided activities.",
    "profile.personalData": "Personal data",
    "profile.fullName": "Full name",
    "profile.email": "Email",
    "profile.phone": "Phone",
    "profile.dob": "Date of birth",
    "profile.weight": "Weight",
    "profile.ccNumber": "ID card number",
    "profile.ccPlaceholder": "Citizen card number",
    "profile.emergencyContact": "Emergency contact",
    "profile.emergencyPlaceholder": "Name + phone",
    "profile.guideDescription": "Guide description",
    "profile.guideDescriptionPlaceholder":
      "Tell users about your experience and guiding style.",
    "profile.alerts": "Alerts",
    "profile.offTrail": "Enable off-trail alert (40 m)",
    "profile.proximityAlerts": "Receive proximity alerts",
    "profile.faunaAlerts": "Receive fauna alerts",
    "profile.trailAlerts": "Receive trail alerts",
    "profile.securityAlerts": "Receive safety alerts",
    "profile.vibrateAlerts": "Vibrate when approaching",
    "profile.soundAlerts": "Sound when approaching",
    "profile.criticalAlerts": "Receive critical alerts",
    "profile.saving": "Saving...",
    "profile.save": "Save changes",
    "profile.logout": "Sign out",
    "profile.deleteTitle": "⚠️ Delete account",
    "profile.deleteBody":
      "This action is permanent and will delete your account and all associated data (profile, trails, messages, and records).",
    "profile.deleteButton": "Delete account permanently",
    "profile.deleteModalTitle": "Delete account",
    "profile.deleteModalBody":
      "By deleting your account, all your data will be permanently erased, including:",
    "profile.deleteModalItem1": "Profile and personal data",
    "profile.deleteModalItem2": "Trails and history",
    "profile.deleteModalItem3": "Messages and groups",
    "profile.deleteModalItem4": "Records and shares",
    "profile.deleteModalWarning":
      "This action is irreversible and cannot be undone.",
    "profile.deleteModalConfirm": "Delete account permanently",
    "profile.deleteModalLoading": "Deleting account...",
    "profile.cancel": "Cancel",
    "profile.photoUploadError": "❌ Failed to upload photo.",
    "profile.photoUpdateSuccess": "✅ Photo updated!",
    "profile.photoUpdateError": "❌ Failed to update photo.",
    "profile.profileUpdateSuccess": "✅ Profile updated!",
    "profile.profileUpdateError": "❌ Failed to save.",
    "profile.trophies.open": "View events I attended",
    "profile.trophies.modalTitle": "My participations",
    "profile.trophies.modalSubtitle":
      "Events where I attended ({count})",
    "profile.trophies.empty": "You don't have participations yet.",
    "profile.trophies.dateUnknown": "Date to be defined",
    "profile.trophies.actionTitle": "Participation",
    "profile.trophies.actionSubtitle": "Choose what you want to open for {event}.",
    "profile.trophies.actionViewEvent": "View event",
    "profile.trophies.actionGallery": "Gallery",
    "profile.trophies.galleryTitle": "Participation gallery",
    "profile.trophies.gallerySubtitle": "{event} • {count} photo(s)",
    "profile.trophies.galleryUploader": "Upload photos to share with participants",
    "profile.trophies.galleryUploadLabel": "You can upload {remaining} more photo(s) for this participation.",
    "profile.trophies.galleryLimitReached": "You already reached the limit of 10 photos for this participation.",
    "profile.trophies.galleryLoading": "Loading gallery...",
    "profile.trophies.galleryEmpty": "There are no photos in this album yet.",
    "profile.trophies.galleryUploadSaved": "✅ Photo added to the participation gallery.",
    "profile.trophies.galleryUploadError": "❌ Failed to save photo in gallery.",
    "profile.trophies.galleryDelete": "Delete",
    "profile.trophies.galleryDeleting": "Deleting...",
    "profile.trophies.galleryDeleteSuccess": "✅ Photo removed from the gallery.",
    "profile.trophies.galleryDeleteError": "❌ Failed to delete photo from the gallery.",
    "profile.deleteSuccess": "✅ Account deleted successfully.",
    "profile.deleteLoginRequired":
      "❌ For security, please log in again and try once more.",
    "profile.deleteError": "❌ Failed to delete account.",
    "forgot.title": "Reset password",
    "forgot.description": "Enter the email for your Trekkin account.",
    "forgot.placeholderEmail": "Your email",
    "forgot.sending": "Sending...",
    "forgot.sendLink": "Send recovery link",
    "forgot.backToLogin": "Back to login",
    "forgot.toast.invalidEmail": "❗ Enter a valid email.",
    "forgot.toast.sent": "📩 We sent a recovery link to your email.",
    "forgot.toast.error": "❌ Failed to send recovery email.",
    "share.alert.authRequired": "You need to be logged in to share.",
    "logs.alert.empty": "No logs to export.",
    "logs.alert.exportError": "Failed to export logs.",
    "groupChat.alert.sendFail": "Failed to send. Check your internet.",
    "groupChat.alert.reported": "Message reported. Thank you.",
    "groupChat.alert.reportFail": "Failed to report. Try again.",
    "groupChat.alert.userBlocked": "User blocked.",
    "groupChat.alert.blockFail": "Failed to block.",
    "chat.action.reply": "Reply",
    "chat.action.report": "Report message",
    "chat.action.block": "Block user",
    "chat.action.unblock": "Unblock",
    "chat.action.delete": "Delete message",
    "chat.reactions.title": "Reactions",
    "chat.reactions.close": "Close reactions",
    "chat.reactions.show": "See who reacted ({count})",
    "chat.reactions.loading": "Loading…",
    "chat.reactions.unknownUser": "User",
    "globalChat.alert.sendFail": "Failed to send. Check your internet.",
    "globalChat.alert.reported": "Message reported. Thank you.",
    "globalChat.alert.reportFail": "Failed to report. Try again.",
    "globalChat.alert.userBlocked": "User blocked.",
    "globalChat.alert.blockFail": "Failed to block. Try again.",
    "directChat.alert.sendFail": "Failed to send message.",
    "directChat.alert.startFail": "Could not start a new chat.",
    "adminReports.alert.updateFail": "Failed to update report.",
    "adminReports.alert.resolved": "Message removed and report resolved.",
    "adminReports.alert.removeFail": "Failed to remove message.",
    "adminReports.deletedMessage": "[message removed by moderator]",
    "guide.alert.groupNameRequired": "Give the group a name!",
    "guide.alert.createGroupFail": "Could not create the group.",
    "guide.alert.membersOnly": "Only group members can use the chat.",
    "guide.alert.openChatFail": "Could not open this group's chat.",
    "login.title.register": "Create Trekkin account",
    "login.title.login": "Sign in",
    "login.placeholder.email": "Email",
    "login.placeholder.password": "Password",
    "login.placeholder.confirmPassword": "Confirm password",
    "login.placeholder.firstName": "First name",
    "login.placeholder.lastName": "Last name",
    "login.placeholder.username": "Username (e.g. trekkinlord)",
    "login.terms.prefix": "I have read and accept the",
    "login.terms.linkText": "Terms of Use",
    "login.terms.suffix":
      ", including the zero-tolerance policy for abusive or offensive content.",
    "login.button.wait": "Please wait…",
    "login.button.register": "Create account",
    "login.button.login": "Sign in",
    "login.toggle.toLogin": "I already have an account — sign in",
    "login.toggle.toRegister": "No account yet — create one",
    "login.forgot": "Forgot password",
    "login.msg.fillAll": "⚠️ Please fill in all fields.",
    "login.msg.passwordMismatch": "⚠️ Passwords do not match.",
    "login.msg.usernameInvalid":
      "⚠️ Invalid username. Use only lowercase letters, numbers and underscore (3–20 chars).",
    "login.msg.acceptTerms": "⚠️ You must accept the Terms of Use.",
    "login.msg.registerSuccess": "✅ Account created! Signed in.",
    "login.msg.emailExists": "⚠️ An account with this email already exists.",
    "login.msg.registerFail": "❌ Could not create the account.",
    "login.msg.registerUnexpected": "❌ Unexpected error while creating account.",
    "login.msg.loginSuccess": "✅ Signed in!",
    "login.msg.invalidCredentials": "❌ Incorrect email or password.",
    "login.msg.loginError": "❌ Error signing in.",
    "setNewPassword.title": "Set new password",
    "setNewPassword.placeholder": "New password",
    "setNewPassword.button.updating": "Updating...",
    "setNewPassword.button.update": "Update password",
    "setNewPassword.msg.tooShort": "❗ Password must be at least 6 characters.",
    "setNewPassword.msg.success": "✅ Password updated successfully!",
    "setNewPassword.msg.invalidCode": "❌ Invalid or expired code.",
    "hud.latLon": "Lat/Lon",
    "hud.accuracy": "Accuracy",
    "hud.speedFiltered": "Speed (filtered)",
    "hud.raw": "RAW",
    "hud.historyPoints": "hist pts",
    "hud.altitude": "Altitude",
    "hud.gpsStatus": "GPS status",
    "chart.elevation.loading": "Preparing elevation profile…",
    "chart.elevation.noData": "No elevation data yet.",
    "chart.stats.distance": "Distance:",
    "chart.stats.ascent": "Ascent:",
    "chart.stats.descent": "Descent:",
    "trail.title": "Trekkin Trails & Events",
    "trail.license.itp": "Registered in ITP under the licence: RNAAT No. 1096/2023",
    "trail.license.icnf": "Recognized as Nature Tourism by ICNF.",
    "trail.section.trails": "Available trails",
    "trail.globalChat": "Global Chat",
    "trail.someone": "someone",
    "trail.events.title": "Trekkin Events",
    "trail.noImage": "No image",
    "trail.dateTbd": "Date to be defined",
    "trail.locationPrefix": "Location:",
    "trail.noEvents": "No events available.",
    "trail.pastEvents": "Past events",
    "trail.fallback.trail": "Trail",
    "trail.fallback.event": "Event",
    "trailItem.title.editName": "Edit name",
    "trailItem.prompt.rename": "New trail name:",
    "trailItem.toast.deleted": "🗑️ Trail \"{name}\" deleted.",
    "trailDetails.noTrailSelected": "No trail selected.",
    "trailDetails.back": "Back",
    "trailDetails.noPermissionView":
      "🔒 Your plan does not allow viewing trail details. Subscribe to Explorer, Adventure or Guide.",
    "trailDetails.noPermissionEdit":
      "❗ Your plan does not allow editing trails. Subscribe to Explorer, Adventure or Guide.",
    "trailDetails.cannotEdit": "This trail cannot be edited.",
    "trailDetails.notEnoughPoints": "Not enough points to edit.",
    "trailDetails.noPermissionDelete":
      "❗ Your plan does not allow deleting trails. Subscribe to Explorer, Adventure or Guide.",
    "trailDetails.confirmDelete": "Delete this trail permanently?",
    "trailDetails.deleted": "🗑️ Trail deleted.",
    "trailDetails.noPermissionLinkEvent":
      "❗ Your plan does not allow creating or linking events. Subscribe to Explorer, Adventure or Guide.",
    "trailDetails.coordsUnavailable": "Coordinates not available.",
    "trailDetails.enterValidName": "Enter a valid name.",
    "trailDetails.nameUpdated": "Trail name updated.",
    "trailDetails.loadingTrail": "Loading trail...",
    "trailDetails.pointsLabel": "points",
    "trailDetails.primary": "Primary",
    "trailDetails.alternative": "Alternative",
    "trailDetails.tour": "Tour",
    "trailDetails.day": "Day",
    "trailDetails.action.edit": "Edit",
    "trailDetails.action.addToEvent": "Add to event",
    "trailDetails.action.navigate": "Navigate",
    "trailDetails.action.delete": "Delete",
    "liveShare.title": "Live share",
    "liveShare.ended": "Share ended — last position visible.",
    "liveShare.noPermissionOpen": "❗ Your plan does not allow opening Live Share. Subscribe to Explorer, Adventure or Guide.",
    "liveShare.noPositionYet": "⚠️ No position yet.",
    "liveShare.elevationProfile": "Elevation profile",
    "liveShare.timeAgo.justNow": "just now",
    "liveShare.timeAgo.seconds": "{n}s ago",
    "liveShare.timeAgo.minutes": "{n}m ago",
    "liveShare.timeAgo.hours": "{n}h ago",
    "intro.loading": "Starting the app...",
    "nav.title": "Navigation",
    "nav.description": "Load a GPX trail, follow a route, or record freely.",
    "nav.loadGpx": "Load\nGPX",
    "nav.record.start": "Record",
    "nav.record.stop": "Stop",
    "nav.record.pause": "Pause",
    "nav.record.resume": "Resume",
    "nav.record.finish": "Finish",
    "nav.stats.time": "Time",
    "nav.stats.stopped": "Stopped",
    "nav.stats.moving": "Moving",
    "nav.stats.average": "Average",
    "nav.stats.ascent": "Ascent",
    "nav.stats.distance": "Distance",
    "nav.stats.altitude": "Altitude",
    "nav.stats.location": "Location",
    "nav.chart.recording": "Recording",
    "nav.chart.altimetry": "Elevation",
    "nav.chart.heartRate": "Heart rate",
    "nav.heartRate.title": "HEART RATE",
    "nav.heartRate.searching": "Searching for sensor…",
    "nav.heartRate.permissionDenied": "Permission not granted",
    "nav.heartRate.noSensor": "No sensor connected",
    "nav.resume.nextDayPrompt":
      "Recording \"{name}\" started on a previous day. Continue this route?\n\nOK: Continue same route\nCancel: Start new route",
    "nav.resume.farPrompt":
      "You are far from the last recorded point (~{distanceM} m). Continue the same route?\n\nOK: Continue same route\nCancel: Start new route",
    "nav.toast.autoPausedInactive": "⏸️ Recording auto-paused due to inactivity.",
    "nav.toast.resumedRecording": "▶️ Recording resumed.",
    "nav.toast.startedNewRecording": "✅ New recording started.",
    "nav.history": "History",
    "nav.waypoints": "Waypoints",
    "nav.liveShare.start": "Share",
    "nav.liveShare.stop": "Stop sharing",
    "nav.toast.historyDenied": "❗ Your plan does not allow viewing history. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.waypointsDenied": "❗ Your plan does not allow accessing Waypoints. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.liveShareDenied": "❗ Your plan does not allow Live Share. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.startNavDenied": "❗ Your plan does not allow starting navigation. Subscribe to Explorer, Adventure or Guide.",
    "nav.waypoint.stop": "Stop navigation",
    "nav.waypoint.add": "Add",
    "nav.waypoint.destination": "Destination: {name}",
    "nav.waypoint.queue": "{n} waypoint(s) queued",
    "nav.waypoint.none": "No navigation active",
    "nav.toast.stopNavDenied": "❗ Your plan does not allow stopping navigation. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.navEnded": "Navigation ended.",
    "nav.toast.createTrailsDenied": "❗ Your plan does not allow creating trails. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.planRoutesDenied": "❗ Your plan does not allow planning routes. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.uploadGpxDenied": "❗ Your plan does not allow uploading GPX trails. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.trailUploaded": "✅ Trail \"{name}\" uploaded.",
    "nav.toast.trailUploadError": "❌ Failed to load GPX file.",
    "nav.toast.liveEnded": "🛑 LIVE ended.",
    "nav.toast.liveCreated": "🔗 LIVE created!",
    "nav.toast.copyLinkSuccess": "📋 Link copied!",
    "nav.toast.copyLinkManual": "⚠️ Please copy it manually above.",
    "nav.toast.noTrailsLoaded": "No trails loaded yet.",
    "nav.toast.trailDisabled": "🛑 Trail disabled.",
    "nav.toast.startLoadedTrailDenied":
      "❗ Your plan does not allow starting uploaded trails. Subscribe to Explorer, Adventure or Guide.",
    "nav.toast.trailActive": "🧭 Trail \"{name}\" active.",
    "nav.toast.trailNoValidPoints": "⚠️ Trail has no valid points.",
    "nav.bg.title": "Background recording",
    "nav.bg.body":
      "Trekkin.pt needs access to your location even when the app is in the background (screen locked) to:",
    "nav.bg.bullet1": "Record your trail accurately",
    "nav.bg.bullet2": "Keep navigation and metrics during your walk",
    "nav.bg.bullet3":
      "(Optional) Share your position with your group when LIVE mode is active",
    "nav.bg.note":
      "You can disable this permission at any time in Android Settings.",
    "nav.bg.skip": "Not now",
    "nav.bg.continue": "Continue",
    "nav.createTrail": "Create trail",
    "nav.createRoute": "Create route",
    "nav.draw.save": "Save drawn trail",
    "nav.draw.clear": "Clear drawing",
    "nav.draw.defaultName": "Drawn trail",
    "nav.draw.notEnoughPoints": "Not enough points.",
    "nav.draw.saveFailed": "Failed to save trail.",
    "nav.draw.saved": "Trail saved.",
    "nav.fallback.waypoint": "Waypoint",
    "nav.weather.nextHours": "Weather · next 3 hours",
    "nav.weather.waitingLocation": "Waiting for location to load the forecast.",
    "navRealtime.title": "Real-time monitoring",
    "navRealtime.noGroup": "You don't have any group selected yet.",
    "navRealtime.subtitle": "Track the group guide in real time (Firebase).",
    "navRealtime.status.connected": "Connected to group",
    "navRealtime.status.noData": "No real-time data",
    "navRealtime.backToNav": "Back to Nav",
    "history.title": "My History",
    "history.state.cloudActive": "Cloud enabled",
    "history.state.cloudDesc": "Recordings are synced automatically.",
    "history.state.localOnly": "Local-only data",
    "history.state.localDesc": "Recordings stay on this device only.",
    "history.empty": "You don't have any recordings yet.",
    "history.cloud.synced": "☁️ Synced",
    "history.cloud.pending": "⏳ Pending sync",
    "history.cloud.local": "📍 Local only",
    "history.action.follow": "Follow",
    "history.action.details": "Details",
    "history.action.download": "Download",
    "history.action.delete": "Delete",
    "history.action.shareImage": "Share activity image",
    "history.recovery.action": "Recover local recording",
    "history.progress.title": "Progress",
    "history.progress.loading": "Updating progress…",
    "history.progress.years": "Years",
    "history.progress.months": "Months",
    "history.progress.weeks": "Weeks",
    "history.progress.period": "Statistics period: {period}",
    "history.progress.distance": "Distance",
    "history.progress.accumulated": "Accumulated",
    "history.progress.accumulatedDPlus": "Accumulated D+",
    "history.progress.windowWeeks": "{count}-week window",
    "history.progress.windowMonths": "{count}-month window",
    "history.progress.windowYears": "{count}-year window",
    "history.alert.deleteDenied": "❗ Your plan does not allow deleting recordings. Subscribe to Explorer, Adventure or Guide.",
    "history.confirm.delete": "Delete this recording permanently?",
    "history.alert.downloadDenied": "❗ Your plan does not allow downloading GPX. Subscribe to Explorer, Adventure or Guide.",
    "history.alert.insufficientData": "This trail doesn't have enough data.",
    "history.alert.androidFilesystemUnavailable": "Android: Filesystem plugin not available.",
    "history.alert.androidWriteFail": "Android: failed to write GPX.",
    "history.alert.androidShareUnavailable": "Android: Share/Browser plugin not available.",
    "history.alert.exportNavDenied": "❗ Your plan does not allow exporting to the grid. Subscribe to Explorer, Adventure or Guide.",
    "history.confirm.exportNav": "Add this trail to the navigation grid?",
    "history.toast.noValidPoints": "Trail has no valid points.",
    "history.toast.tooFewPointsAfterDedup": "Too few points after removing duplicates.",
    "history.toast.addedToNavGrid": "Trail added to the grid.",
    "history.alert.followDenied": "❗ Your plan does not allow following trails. Subscribe to Explorer, Adventure or Guide.",
    "history.alert.noValidPoints": "This trail has no valid points.",
    "eventList.toast.invalidTrail": "Invalid trail.",
    "eventList.emptyUpcoming.title": "New adventures are on the way!",
    "eventList.emptyUpcoming.body": "We're preparing new events and improving your app experience. Check back soon — more trails are waiting to be discovered!",
    "eventList.toast.primaryTrailDenied": "❗ Your plan does not allow setting the primary trail. Subscribe to Explorer, Adventure or Guide.",
    "eventList.toast.altTrailDenied": "❗ Your plan does not allow adding alternative trails. Subscribe to Explorer, Adventure or Guide.",
    "eventList.toast.noGpxAvailable": "No GPX available for this trail.",
    "eventList.toast.invalidGpx": "Invalid GPX.",
    "eventList.toast.primaryUpdated": "✅ Primary trail updated.",
    "eventList.toast.altAdded": "✅ Alternative trail added to the event.",
    "eventList.toast.tourAdded": "✅ Tour route added to the event.",
    "eventList.toast.noMeetingPoints": "This event has no day trails available.",
    "eventList.prompt.pickDay": "Choose the day number to link this trail:",
    "eventList.toast.invalidDay": "Invalid day.",
    "eventList.toast.dayUpdated": "✅ Trail updated on Day {day}.",
    "eventList.toast.addTrailError": "❌ Error adding trail to the event.",
    "eventDetails.title": "Event details",
    "eventDetails.state.invalid": "Invalid event or not found.",
    "eventDetails.state.loading": "Loading event…",
    "eventDetails.fallback.guideName": "Event guide",
    "eventDetails.fallback.lodgingName": "Event lodging",
    "eventDetails.toast.cannotOpenNavigation": "Couldn't open navigation.",
    "eventDetails.toast.loadingTryAgain": "Event is still loading. Try again.",
    "eventDetails.toast.noPermissionContactGuide": "You don't have permission to contact the guide. Subscribe to Explorer, Adventure or Guide.",
    "eventDetails.toast.loginRequiredContactGuide": "Login is required to contact the guide.",
    "eventDetails.toast.guideNotFound": "Guide not found.",
    "eventDetails.toast.cannotOpenChat": "Couldn't open chat with the guide.",
    "eventDetails.toast.alreadyRegistered": "You're already enrolled in this event.",
    "eventDetails.toast.cannotOpenVideo": "Couldn't open the video.",
    "eventDetails.access.inviteOnlyTitle": "Invite-only event",
    "eventDetails.access.privateTitle": "Private event",
    "eventDetails.access.inviteOnlyLine1": "This event is invite-only!",
    "eventDetails.access.inviteOnlyLine2": "For more information, contact the event guide.",
    "eventDetails.access.requestInvite": "Request an invitation",
    "eventDetails.access.requestAgain": "Request an invitation again",
    "eventDetails.access.requestSending": "Sending…",
    "eventDetails.access.requestPendingShort": "Invitation request pending.",
    "eventDetails.access.requestPending": "Invitation request awaiting the guide's decision.",
    "eventDetails.access.requestRejected": "The previous request was not accepted.",
    "eventDetails.access.privateBody":
      "This event isn't public or hasn't been published yet. Only the guide or admins can access it.",
    "eventDetails.access.contactGuide": "Contact the guide ({name})",
    "eventDetails.header.fallbackName": "Trekkin event",
    "guide.actions.whatsappGroup": "Join the Trekkin community",
    "guide.actions.whatsappCommunityHint": "News, stories and adventures on WhatsApp",
    "guide.newsletter.title": "Trekkin news in your inbox",
    "guide.newsletter.description": "Discover new trails, events and adventures first.",
    "guide.newsletter.subscribe": "Subscribe to newsletter",
    "eventDetails.header.badge": "Trekkin Event",
    "eventDetails.unit.day": "day",
    "eventDetails.unit.days": "days",
    "eventDetails.overview.distance": "total distance",
    "eventDetails.overview.ascent": "elevation gain",
    "eventDetails.overview.price": "event price",
    "eventDetails.registration.enroll": "Register",
    "eventDetails.registration.chooseDays": "Choose days and register",
    "eventDetails.registration.multiDayLabel": "Join for 1 or more days",
    "eventDetails.registration.byDayTitle": "Registration by day available",
    "eventDetails.registration.byDayBody": "Join the full event or select only the days you want to attend.",
    "eventDetails.registration.byDayBadge": "Full event or individual days",
    "eventDetails.registration.fullPrice": "Full event",
    "eventDetails.registration.dayPriceFrom": "One day from",
    "eventDetails.registration.extrasNote": "The total updates according to the selected days and extras such as lodging, meals or transfer.",
    "eventDetails.registration.pendingShort": "Registration pending",
    "eventDetails.transfer.fromPrice": "Transfer from €{price}",
    "eventDetails.transfer.available": "Transfer available",
    "eventDetails.cancellation.title": "Cancellation policy",
    "eventDetails.shortcuts.gallery": "Gallery",
    "eventDetails.shortcuts.trails": "Trails",
    "eventDetails.shortcuts.lodging": "Lodging",
    "eventDetails.shortcuts.share": "Share",
    "eventDetails.capture.button": "Create full event image",
    "eventDetails.capture.working": "Creating image…",
    "eventDetails.capture.preparing": "Preparing the full event image…",
    "eventDetails.capture.shareTitle": "Share event image",
    "eventDetails.capture.saved": "Event image saved.",
    "eventDetails.capture.error": "Couldn't create the full event image.",
    "eventDetails.actions.edit": "Edit event",
    "eventDetails.shortcuts.openSharedEvent": "View the details and register:",
    "eventDetails.general.title": "General information",
    "eventDetails.general.startDate": "Start date",
    "eventDetails.general.duration": "Duration",
    "eventDetails.general.price": "Price",
    "eventDetails.general.tbd": "To be defined",
    "eventDetails.general.transferOptional": "Transfer (optional)",
    "eventDetails.meals.globalTitle": "Event meals",
    "eventDetails.action.hide": "Hide",
    "eventDetails.action.view": "View",
    "eventDetails.info.dateTime": "Date & time",
    "eventDetails.info.dateTbd": "Date to be defined",
    "eventDetails.info.price": "Event price",
    "eventDetails.info.free": "Free",
    "eventDetails.info.slots": "Slots",
    "eventDetails.info.available": "Available",
    "eventDetails.info.availableYes": "Yes",
    "eventDetails.info.soldOut": "Sold out",
    "eventDetails.info.noLimit": "No limit set",
    "eventDetails.transfer.title": "Transfer",
    "eventDetails.transfer.price": "Price",
    "eventDetails.transfer.noPrice": "No price set",
    "eventDetails.transfer.seats": "Seats",
    "eventDetails.transfer.time": "Time",
    "eventDetails.transfer.startPoint": "Transfer start point",
    "eventDetails.meetingPoint.title": "Event meeting point",
    "eventDetails.publish.onlyVisible":
      "This event isn't published yet. Visible only to the guide, admin and associated partners.",
    "eventDetails.guide.title": "Guide",
    "eventDetails.guide.avatarAlt": "Guide",
    "eventDetails.guide.responsible": "Responsible guide",
    "eventDetails.guide.contactTitle": "Message the guide",
    "eventDetails.coGuide.title": "Co-guide",
    "eventDetails.coGuide.avatarAlt": "Co-guide",
    "eventDetails.coGuide.fallbackName": "Co-guide",
    "eventDetails.coGuide.responsible": "Responsible co-guide",
    "eventDetails.coGuide.contactTitle": "Message the co-guide",
    "eventDetails.registration.title": "Registration",
    "eventDetails.registration.cta": "Register and see available options!",
    "eventDetails.registration.pending": "Registration submitted. Awaiting confirmation.",
    "eventDetails.registration.confirmed": "Registration confirmed.",
    "eventDetails.gallery.title": "Event gallery",
    "eventDetails.gallery.thumbAlt": "Event gallery",
    "eventDetails.gallery.fullAlt": "Event image",
    "eventDetails.teaser.title": "Event teaser",
    "eventDetails.teaser.subtitle": "Intro video prepared by the guide.",
    "eventDetails.summary.title": "Event summary",
    "eventDetails.altimetry.title": "Elevation profile & overall route",
    "eventDetails.altimetry.distance": "Distance",
    "eventDetails.altimetry.noGpx": "No global GPX set for this event.",
    "eventDetails.altimetry.preparing": "Preparing elevation profile…",
    "eventDetails.days.title": "Days and meeting points",
    "eventDetails.days.empty": "This event has no additional days configured.",
    "eventDetails.included.title": "Included in the event",
    "eventDetails.shouldBring.title": "What to bring",
    "eventDetails.technicalDetails.title": "Technical details",
    "eventDetails.longDescription.title": "Full details",
    "eventDetails.error.weather": "Couldn't fetch the weather forecast.",
    "eventDetails.error.altimetry": "Couldn't calculate the elevation profile.",
    "eventDetails.weather.title": "Weather forecast",
    "eventDetails.weather.loading": "Loading forecast…",
    "eventDetails.weather.na": "N/A",
    "eventDetails.weather.precipProb": "Precip. chance",
    "eventDetails.weather.wind": "Wind",
    "eventDetails.weather.notAvailableAccurate":
      "Forecast not available (event date is too far away).",
    "eventDetails.weather.notAvailable": "Forecast not available.",
    "eventDetails.weather.condition.clear": "Clear",
    "eventDetails.weather.condition.partlyCloudy": "Partly cloudy",
    "eventDetails.weather.condition.fog": "Fog",
    "eventDetails.weather.condition.drizzle": "Drizzle",
    "eventDetails.weather.condition.rain": "Rain",
    "eventDetails.weather.condition.freezingRain": "Freezing rain",
    "eventDetails.weather.condition.snow": "Snow",
    "eventDetails.weather.condition.showers": "Showers",
    "eventDetails.weather.condition.snowShowers": "Snow showers",
    "eventDetails.weather.condition.thunderstorm": "Thunderstorm",
    "eventDetails.weather.condition.notAvailable": "N/A",
    "eventDetails.lodging.globalTitle": "Global lodging",
    "eventDetails.lodging.lodging": "Lodging",
    "eventDetails.lodging.camping": "Camping",
    "eventDetails.lodging.price.free": "Free",
    "eventDetails.lodging.price.included": "Included",
    "eventDetails.lodging.note":
      "Note: prices are per person/night (when applicable). Lodging is selected during registration.",
    "eventDay.day": "Day {n}",
    "eventDay.distance": "Day distance",
    "eventDay.meetingPoint": "Meeting point",
    "eventDay.notDefined": "Not set yet",
    "eventDay.weather": "Weather",
    "eventDay.lodging.title": "Lodging",
    "eventDay.lodging.fallbackName": "Lodging",
    "eventDay.price.free": "Free",
    "eventDay.price.included": "Included",
    "eventDay.price.perPerson": "{price} per person",
    "eventDay.price.wholeProperty": "{price} for the property",
    "eventDay.price.capacity": "{count} people",
    "eventDay.inventory.doubleBed": "{count} double bed",
    "eventDay.inventory.doubleBeds": "{count} double beds",
    "eventDay.inventory.singleBed": "{count} single bed",
    "eventDay.inventory.singleBeds": "{count} single beds",
    "eventDay.inventory.capacity": "capacity: {count} people",
    "eventDay.price.doubleRoom": "Double bed: {price}",
    "eventDay.price.singleRoom": "Single bed: {price}",
    "eventDay.price.perRoom": "{price} per room",
    "eventDay.price.twoPersonTent": "2-person tent: +{price}",
    "eventDay.price.onePersonTent": "Individual tent: +{price}",
    "eventDay.meals.title": "Meals of the day",
    "eventDay.meals.fallbackName": "Meal",
    "eventDay.route.title": "Route of the day",
    "eventDay.elevation.min": "Min. alt.",
    "eventDay.elevation.max": "Max. alt.",
    "eventRegister.state.notFound": "Event not found.",
    "eventRegister.title": "Event registration",
    "eventRegister.subtitle": "Fill in your details and confirm your registration.",
    "eventRegister.participants.title": "Participants",
    "eventRegister.participants.subtitle":
      "You can add more people to your registration.",
    "eventRegister.participants.add": "Add participant",
    "eventRegister.participants.nameLabel": "Name (optional)",
    "eventRegister.participants.emailLabel": "Email",
    "eventRegister.participants.remove": "Remove",
    "eventRegister.participants.sameOptions": "Same options for everyone",
    "eventRegister.participants.editOptions": "Edit options for",
    "eventRegister.participants.ownerLabel": "Me (owner)",
    "eventRegister.participants.inviteeLabel": "Guest {n}",
    "eventRegister.participants.editing": "Editing options for",
    "eventRegister.participants.invalidEmail":
      "Please enter valid emails for the participants.",
    "eventRegister.participants.duplicateEmail":
      "There are duplicate emails in the participants list.",
    "eventRegister.participants.ownerEmailConflict":
      "You can't add your own email as a guest.",
    "eventRegister.required.title": "Required information",
    "eventRegister.required.ccLabel": "ID card number",
    "eventRegister.required.ccPlaceholder": "Citizen card number",
    "eventRegister.required.dobLabel": "Date of birth",
    "eventRegister.participation.title": "Participation",
    "eventRegister.participation.fullEvent": "Full event",
    "eventRegister.participation.selectDays": "Select days",
    "eventRegister.participation.day": "Day {n}",
    "eventRegister.transfer.fullEventOnly": "Transfer is available only when registering for the full event.",
    "eventRegister.validation.selectAtLeastOneDay": "Select at least one day.",
    "eventRegister.error.ccRequired": "Please enter your ID card number.",
    "eventRegister.error.dobRequired": "Please enter your date of birth.",
    "eventRegister.toast.submitted": "✅ Registration submitted!",
    "eventRegister.toast.error": "❌ Failed to submit registration.",
    "eventRegister.lodging.infoTitle": "Lodging",
    "eventRegister.lodging.infoGlobal":
      "This event has a global lodging option (applies to all days).",
    "eventRegister.lodging.infoPerDay": "This event has lodging options per day.",
    "eventRegister.lodging.lodging": "Lodging",
    "eventRegister.lodging.camping": "Camping",
    "eventRegister.lodging.globalTitleFull": "Global lodging (full event)",
    "eventRegister.lodging.globalTitleSelected": "Global lodging (selected days)",
    "eventRegister.lodging.globalTitle": "Global lodging",
    "eventRegister.lodging.globalNone": "No global lodging",
    "eventRegister.lodging.price.free": "Free",
    "eventRegister.lodging.price.included": "Included",
    "eventRegister.lodging.lodgingFallback": "Lodging",
    "eventRegister.lodging.perDayTitleFull": "Lodging per day (full event)",
    "eventRegister.lodging.perDayTitleSelected": "Lodging per day (selected days)",
    "eventRegister.lodging.selectDaysForOptions": "Select days to see options.",
    "eventRegister.lodging.noneThisDay": "No lodging for this day",
    "eventRegister.lodging.thisDayTitle": "Lodging for this day",
    "eventRegister.lodging.none": "No lodging",
    "eventRegister.lodging.tentSummary": "Tents: {two} for 2 people · {one} for 1 person",
    "eventRegister.lodging.perPerson": "Price per person",
    "eventRegister.lodging.participantOnly": "This choice applies only to this participant.",
    "eventRegister.transfer.title": "Transfer",
    "eventRegister.transfer.add": "Add transfer",
    "eventRegister.breakdown.title": "Registration summary",
    "eventRegister.breakdown.fullEvent": "Full event",
    "eventRegister.breakdown.participationDays": "Participation (days)",
    "eventRegister.breakdown.transfer": "Transfer",
    "eventRegister.breakdown.globalLodging": "Global lodging",
    "eventRegister.breakdown.dayLodging": "Day lodging",
    "eventRegister.breakdown.lodging": "Lodging",
    "eventRegister.breakdown.total": "Total",
    "eventRegister.singleDay.title": "Participation",
    "eventRegister.singleDay.price": "Price",
    "eventRegister.payment.title": "Payment",
    "eventRegister.payment.split": "Each participant pays their own",
    "eventRegister.payment.splitHint":
      "Each participant receives their own payment email.",
    "eventRegister.payment.single": "Single payment (owner)",
    "eventRegister.payment.singleHint":
      "The owner pays the total for everyone.",
    "eventRegister.payment.groupTotal": "Group total",
    "eventRegister.action.submitting": "Submitting…",
    "eventRegister.action.confirm": "Confirm registration",
    "eventEnroll.loading": "Loading…",
    "eventEnroll.notFound": "Registration not found.",
    "eventEnroll.title": "Registration received",
    "eventEnroll.subtitle": "We received your registration for",
    "eventEnroll.price.included": "Included",
    "eventEnroll.participation.title": "Participation",
    "eventEnroll.participation.fullEvent": "Full event",
    "eventEnroll.participation.day": "Day {n}",
    "eventEnroll.transfer.title": "Transfer",
    "eventEnroll.lodging.title": "Lodging",
    "eventEnroll.lodging.globalPrefix": "Global lodging",
    "eventEnroll.lodging.none": "No lodging selected.",
    "eventEnroll.payment.title": "Payment",
    "eventEnroll.payment.body1": "Payment instructions will be sent by email.",
    "eventEnroll.payment.body2":
      "If you don't receive it, check your spam folder or contact us.",
    "eventEnroll.payment.groupOwner": "The owner pays the total for the group.",
    "eventEnroll.total.title": "Total",
    "eventEnroll.total.groupTitle": "Group total",
  },
  it: {
    "settings.appearance": "Aspetto",
    "settings.language": "Lingua",
    "settings.theme.system": "Sistema",
    "settings.theme.light": "Chiaro",
    "settings.theme.dark": "Scuro",
    "profile.title": "Profilo Trekkin",
    "profile.noUser": "Nessun utente autenticato.",
    "profile.accountSection": "Account Trekkin",
    "profile.displayNameFallback": "Trekker senza nome",
    "profile.requiredData": "Dati richiesti per attivita guidate.",
    "profile.personalData": "Dati personali",
    "profile.fullName": "Nome completo",
    "profile.email": "Email",
    "profile.phone": "Telefono",
    "profile.dob": "Data di nascita",
    "profile.weight": "Peso",
    "profile.ccNumber": "Numero carta d'identita",
    "profile.ccPlaceholder": "Numero della carta d'identita",
    "profile.emergencyContact": "Contatto di emergenza",
    "profile.emergencyPlaceholder": "Nome + telefono",
    "profile.alerts": "Avvisi",
    "profile.offTrail": "Attiva avviso fuori sentiero (40 m)",
    "profile.proximityAlerts": "Ricevere avvisi di prossimita",
    "profile.faunaAlerts": "Ricevere avvisi di Fauna",
    "profile.trailAlerts": "Ricevere avvisi di Sentiero",
    "profile.securityAlerts": "Ricevere avvisi di Sicurezza",
    "profile.vibrateAlerts": "Vibrare all'avvicinarsi",
    "profile.soundAlerts": "Suono all'avvicinarsi",
    "profile.criticalAlerts": "Ricevere avvisi critici",
    "profile.saving": "Salvataggio...",
    "profile.save": "Salva modifiche",
    "profile.logout": "Termina sessione",
    "profile.deleteTitle": "⚠️ Elimina account",
    "profile.deleteBody":
      "Questa azione e permanente e eliminera il tuo account e tutti i dati associati (profilo, percorsi, messaggi e registri).",
    "profile.deleteButton": "Elimina account definitivamente",
    "profile.deleteModalTitle": "Elimina account",
    "profile.deleteModalBody":
      "Eliminando il tuo account, tutti i tuoi dati saranno cancellati definitivamente, inclusi:",
    "profile.deleteModalItem1": "Profilo e dati personali",
    "profile.deleteModalItem2": "Percorsi e cronologia",
    "profile.deleteModalItem3": "Messaggi e gruppi",
    "profile.deleteModalItem4": "Registri e condivisioni",
    "profile.deleteModalWarning":
      "Questa azione e irreversibile e non puo essere annullata.",
    "profile.deleteModalConfirm": "Elimina account definitivamente",
    "profile.deleteModalLoading": "Eliminazione account...",
    "profile.cancel": "Annulla",
    "profile.photoUploadError": "❌ Errore durante l'upload della foto.",
    "profile.photoUpdateSuccess": "✅ Foto aggiornata!",
    "profile.photoUpdateError": "❌ Errore durante l'aggiornamento della foto.",
    "profile.profileUpdateSuccess": "✅ Profilo aggiornato!",
    "profile.profileUpdateError": "❌ Errore durante il salvataggio.",
    "profile.deleteSuccess": "✅ Account eliminato con successo.",
    "profile.deleteLoginRequired":
      "❌ Per sicurezza, accedi di nuovo e riprova.",
    "profile.deleteError": "❌ Errore durante l'eliminazione dell'account.",
    "forgot.title": "Recupera password",
    "forgot.description": "Inserisci l'email del tuo account Trekkin.",
    "forgot.placeholderEmail": "La tua email",
    "forgot.sending": "Invio in corso...",
    "forgot.sendLink": "Invia link di recupero",
    "forgot.backToLogin": "Torna al login",
    "forgot.toast.invalidEmail": "❗ Inserisci un'email valida.",
    "forgot.toast.sent": "📩 Abbiamo inviato un link di recupero alla tua email.",
    "forgot.toast.error": "❌ Errore nell'invio dell'email di recupero.",
    "share.alert.authRequired": "Devi essere autenticato per condividere.",
    "logs.alert.empty": "Nessun log da esportare.",
    "logs.alert.exportError": "Errore durante l'esportazione dei log.",
    "groupChat.alert.sendFail": "Invio fallito. Verifica la connessione.",
    "groupChat.alert.reported": "Messaggio segnalato. Grazie.",
    "groupChat.alert.reportFail": "Segnalazione fallita. Riprova.",
    "groupChat.alert.userBlocked": "Utente bloccato.",
    "groupChat.alert.blockFail": "Blocco fallito.",
    "chat.action.reply": "Rispondi",
    "chat.action.report": "Segnala messaggio",
    "chat.action.block": "Blocca utente",
    "chat.action.unblock": "Sblocca",
    "chat.action.delete": "Elimina messaggio",
    "globalChat.alert.sendFail": "Invio fallito. Verifica la connessione.",
    "globalChat.alert.reported": "Messaggio segnalato. Grazie.",
    "globalChat.alert.reportFail": "Segnalazione fallita. Riprova.",
    "globalChat.alert.userBlocked": "Utente bloccato.",
    "globalChat.alert.blockFail": "Blocco fallito. Riprova.",
    "directChat.alert.sendFail": "Errore nell'invio del messaggio.",
    "directChat.alert.startFail": "Impossibile avviare una nuova chat.",
    "adminReports.alert.updateFail": "Aggiornamento del report fallito.",
    "adminReports.alert.resolved": "Messaggio rimosso e report risolto.",
    "adminReports.alert.removeFail": "Rimozione messaggio fallita.",
    "adminReports.deletedMessage": "[messaggio rimosso dal moderatore]",
    "guide.alert.groupNameRequired": "Dai un nome al gruppo!",
    "guide.alert.createGroupFail": "Impossibile creare il gruppo.",
    "guide.alert.membersOnly": "Solo i membri del gruppo possono usare la chat.",
    "guide.alert.openChatFail": "Impossibile aprire la chat di questo gruppo.",
  },
  es: {
    "settings.appearance": "Apariencia",
    "settings.language": "Idioma",
    "settings.theme.system": "Sistema",
    "settings.theme.light": "Claro",
    "settings.theme.dark": "Oscuro",
    "profile.title": "Perfil Trekkin",
    "profile.noUser": "Ningun usuario autenticado.",
    "profile.accountSection": "Cuenta Trekkin",
    "profile.displayNameFallback": "Trekker sin nombre",
    "profile.requiredData": "Datos obligatorios para actividades guiadas.",
    "profile.personalData": "Datos personales",
    "profile.fullName": "Nombre completo",
    "profile.email": "Correo electronico",
    "profile.phone": "Telefono",
    "profile.dob": "Fecha de nacimiento",
    "profile.weight": "Peso",
    "profile.ccNumber": "Numero de DNI",
    "profile.ccPlaceholder": "Numero del documento de identidad",
    "profile.emergencyContact": "Contacto de emergencia",
    "profile.emergencyPlaceholder": "Nombre + telefono",
    "profile.alerts": "Alertas",
    "profile.offTrail": "Activar alerta fuera del sendero (40 m)",
    "profile.proximityAlerts": "Recibir alertas de proximidad",
    "profile.faunaAlerts": "Recibir alertas de Fauna",
    "profile.trailAlerts": "Recibir alertas de Sendero",
    "profile.securityAlerts": "Recibir alertas de Seguridad",
    "profile.vibrateAlerts": "Vibrar al acercarse",
    "profile.soundAlerts": "Sonido al acercarse",
    "profile.criticalAlerts": "Recibir alertas criticas",
    "profile.saving": "Guardando...",
    "profile.save": "Guardar cambios",
    "profile.logout": "Cerrar sesion",
    "profile.deleteTitle": "⚠️ Eliminar cuenta",
    "profile.deleteBody":
      "Esta accion es permanente y eliminara tu cuenta y todos los datos asociados (perfil, rutas, mensajes y registros).",
    "profile.deleteButton": "Eliminar cuenta definitivamente",
    "profile.deleteModalTitle": "Eliminar cuenta",
    "profile.deleteModalBody":
      "Al eliminar tu cuenta, todos tus datos se borraran permanentemente, incluyendo:",
    "profile.deleteModalItem1": "Perfil y datos personales",
    "profile.deleteModalItem2": "Rutas e historial",
    "profile.deleteModalItem3": "Mensajes y grupos",
    "profile.deleteModalItem4": "Registros y compartidos",
    "profile.deleteModalWarning":
      "Esta accion es irreversible y no se puede deshacer.",
    "profile.deleteModalConfirm": "Eliminar cuenta definitivamente",
    "profile.deleteModalLoading": "Eliminando cuenta...",
    "profile.cancel": "Cancelar",
    "profile.photoUploadError": "❌ Error al subir la foto.",
    "profile.photoUpdateSuccess": "✅ Foto actualizada!",
    "profile.photoUpdateError": "❌ Error al actualizar la foto.",
    "profile.profileUpdateSuccess": "✅ Perfil actualizado!",
    "profile.profileUpdateError": "❌ Error al guardar.",
    "profile.deleteSuccess": "✅ Cuenta eliminada correctamente.",
    "profile.deleteLoginRequired":
      "❌ Por seguridad, inicia sesion de nuevo e intentalo otra vez.",
    "profile.deleteError": "❌ Error al eliminar la cuenta.",
    "forgot.title": "Recuperar contraseña",
    "forgot.description": "Introduce el correo de tu cuenta Trekkin.",
    "forgot.placeholderEmail": "Tu correo",
    "forgot.sending": "Enviando...",
    "forgot.sendLink": "Enviar enlace de recuperación",
    "forgot.backToLogin": "Volver al inicio",
    "forgot.toast.invalidEmail": "❗ Introduce un correo válido.",
    "forgot.toast.sent": "📩 Enviamos un enlace de recuperación a tu correo.",
    "forgot.toast.error": "❌ Error al enviar el correo de recuperación.",
    "share.alert.authRequired": "Necesitas iniciar sesion para compartir.",
    "logs.alert.empty": "No hay logs para exportar.",
    "logs.alert.exportError": "Error al exportar logs.",
    "groupChat.alert.sendFail": "No se pudo enviar. Comprueba internet.",
    "groupChat.alert.reported": "Mensaje reportado. Gracias.",
    "groupChat.alert.reportFail": "No se pudo reportar. Intenta de nuevo.",
    "groupChat.alert.userBlocked": "Usuario bloqueado.",
    "groupChat.alert.blockFail": "No se pudo bloquear.",
    "chat.action.reply": "Responder",
    "chat.action.report": "Reportar mensaje",
    "chat.action.block": "Bloquear usuario",
    "chat.action.unblock": "Desbloquear",
    "chat.action.delete": "Eliminar mensaje",
    "globalChat.alert.sendFail": "No se pudo enviar. Comprueba internet.",
    "globalChat.alert.reported": "Mensaje reportado. Gracias.",
    "globalChat.alert.reportFail": "No se pudo reportar. Intenta de nuevo.",
    "globalChat.alert.userBlocked": "Usuario bloqueado.",
    "globalChat.alert.blockFail": "No se pudo bloquear. Intenta de nuevo.",
    "directChat.alert.sendFail": "Error al enviar el mensaje.",
    "directChat.alert.startFail": "No se pudo iniciar un nuevo chat.",
    "adminReports.alert.updateFail": "Error al actualizar el reporte.",
    "adminReports.alert.resolved": "Mensaje eliminado y reporte resuelto.",
    "adminReports.alert.removeFail": "Error al eliminar el mensaje.",
    "adminReports.deletedMessage": "[mensaje eliminado por el moderador]",
    "guide.alert.groupNameRequired": "Pon un nombre al grupo.",
    "guide.alert.createGroupFail": "No se pudo crear el grupo.",
    "guide.alert.membersOnly": "Solo los miembros del grupo pueden usar el chat.",
    "guide.alert.openChatFail": "No se pudo abrir el chat de este grupo.",
  },
  de: {
    "settings.appearance": "Darstellung",
    "settings.language": "Sprache",
    "settings.theme.system": "System",
    "settings.theme.light": "Hell",
    "settings.theme.dark": "Dunkel",
    "profile.title": "Trekkin Profil",
    "profile.noUser": "Kein authentifizierter Benutzer.",
    "profile.accountSection": "Trekkin-Konto",
    "profile.displayNameFallback": "Unbenannter Trekker",
    "profile.requiredData": "Pflichtdaten fur gefuhrte Aktivitaten.",
    "profile.personalData": "Personliche Daten",
    "profile.fullName": "Vollstandiger Name",
    "profile.email": "E-Mail",
    "profile.phone": "Telefon",
    "profile.dob": "Geburtsdatum",
    "profile.weight": "Gewicht",
    "profile.ccNumber": "Personalausweisnummer",
    "profile.ccPlaceholder": "Nummer des Personalausweises",
    "profile.emergencyContact": "Notfallkontakt",
    "profile.emergencyPlaceholder": "Name + Telefon",
    "profile.alerts": "Warnungen",
    "profile.offTrail": "Warnung ausserhalb des Weges aktivieren (40 m)",
    "profile.proximityAlerts": "Nahwarnungen erhalten",
    "profile.faunaAlerts": "Fauna-Warnungen erhalten",
    "profile.trailAlerts": "Weg-Warnungen erhalten",
    "profile.securityAlerts": "Sicherheitswarnungen erhalten",
    "profile.vibrateAlerts": "Beim Annahern vibrieren",
    "profile.soundAlerts": "Beim Annahern Ton",
    "profile.criticalAlerts": "Kritische Warnungen erhalten",
    "profile.saving": "Speichern...",
    "profile.save": "Anderungen speichern",
    "profile.logout": "Abmelden",
    "profile.deleteTitle": "⚠️ Konto loschen",
    "profile.deleteBody":
      "Diese Aktion ist dauerhaft und loscht dein Konto und alle zugehorigen Daten (Profil, Wege, Nachrichten und Aufzeichnungen).",
    "profile.deleteButton": "Konto endgultig loschen",
    "profile.deleteModalTitle": "Konto loschen",
    "profile.deleteModalBody":
      "Beim Loschen deines Kontos werden alle deine Daten dauerhaft entfernt, einschliesslich:",
    "profile.deleteModalItem1": "Profil und personliche Daten",
    "profile.deleteModalItem2": "Wege und Verlauf",
    "profile.deleteModalItem3": "Nachrichten und Gruppen",
    "profile.deleteModalItem4": "Aufzeichnungen und Freigaben",
    "profile.deleteModalWarning":
      "Diese Aktion ist unwiderruflich und kann nicht ruckgangig gemacht werden.",
    "profile.deleteModalConfirm": "Konto endgultig loschen",
    "profile.deleteModalLoading": "Konto wird geloscht...",
    "profile.cancel": "Abbrechen",
    "profile.photoUploadError": "❌ Foto-Upload fehlgeschlagen.",
    "profile.photoUpdateSuccess": "✅ Foto aktualisiert!",
    "profile.photoUpdateError": "❌ Fotoaktualisierung fehlgeschlagen.",
    "profile.profileUpdateSuccess": "✅ Profil aktualisiert!",
    "profile.profileUpdateError": "❌ Speichern fehlgeschlagen.",
    "profile.deleteSuccess": "✅ Konto erfolgreich geloscht.",
    "profile.deleteLoginRequired":
      "❌ Aus Sicherheitsgrunden bitte erneut anmelden und noch einmal versuchen.",
    "profile.deleteError": "❌ Konto konnte nicht geloscht werden.",
    "forgot.title": "Passwort zurucksetzen",
    "forgot.description": "Gib die E-Mail deines Trekkin-Kontos ein.",
    "forgot.placeholderEmail": "Deine E-Mail",
    "forgot.sending": "Wird gesendet...",
    "forgot.sendLink": "Wiederherstellungslink senden",
    "forgot.backToLogin": "Zuruck zum Login",
    "forgot.toast.invalidEmail": "❗ Gib eine gultige E-Mail ein.",
    "forgot.toast.sent": "📩 Wir haben dir einen Wiederherstellungslink gesendet.",
    "forgot.toast.error": "❌ Fehler beim Senden der Wiederherstellungs-E-Mail.",
    "share.alert.authRequired": "Du musst angemeldet sein, um zu teilen.",
    "logs.alert.empty": "Keine Logs zum Exportieren.",
    "logs.alert.exportError": "Fehler beim Exportieren der Logs.",
    "groupChat.alert.sendFail": "Senden fehlgeschlagen. Internet prufen.",
    "groupChat.alert.reported": "Nachricht gemeldet. Danke.",
    "groupChat.alert.reportFail": "Melden fehlgeschlagen. Bitte erneut.",
    "groupChat.alert.userBlocked": "Benutzer blockiert.",
    "groupChat.alert.blockFail": "Blockieren fehlgeschlagen.",
    "chat.action.reply": "Antworten",
    "chat.action.report": "Nachricht melden",
    "chat.action.block": "Benutzer blockieren",
    "chat.action.unblock": "Entsperren",
    "chat.action.delete": "Nachricht löschen",
    "globalChat.alert.sendFail": "Senden fehlgeschlagen. Internet prufen.",
    "globalChat.alert.reported": "Nachricht gemeldet. Danke.",
    "globalChat.alert.reportFail": "Melden fehlgeschlagen. Bitte erneut.",
    "globalChat.alert.userBlocked": "Benutzer blockiert.",
    "globalChat.alert.blockFail": "Blockieren fehlgeschlagen. Bitte erneut.",
    "directChat.alert.sendFail": "Nachricht konnte nicht gesendet werden.",
    "directChat.alert.startFail": "Neuer Chat konnte nicht gestartet werden.",
    "adminReports.alert.updateFail": "Report konnte nicht aktualisiert werden.",
    "adminReports.alert.resolved": "Nachricht entfernt und Report gelost.",
    "adminReports.alert.removeFail": "Nachricht konnte nicht entfernt werden.",
    "adminReports.deletedMessage": "[Nachricht vom Moderator entfernt]",
    "guide.alert.groupNameRequired": "Gib der Gruppe einen Namen.",
    "guide.alert.createGroupFail": "Gruppe konnte nicht erstellt werden.",
    "guide.alert.membersOnly": "Nur Gruppenmitglieder konnen den Chat nutzen.",
    "guide.alert.openChatFail": "Gruppenchat konnte nicht geoffnet werden.",
  },
};

export const languageOptions = [
  { value: "pt", label: "Português" },
  { value: "en", label: "English" },
];

const format = (text, params) => {
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (_, token) => {
    if (params[token] === 0) return "0";
    return params[token] ? String(params[token]) : `{${token}}`;
  });
};

export const t = (lang, key, params) => {
  const text =
    translations[lang]?.[key] ?? translations.pt?.[key] ?? key;
  const formatted = format(text, params);
  if (formatted.includes("Subscreve Explorer, Adventure ou Guide.")) {
    return formatted.replace(
      "Subscreve Explorer, Adventure ou Guide.",
      "Subscreve a app a partir de 3,50 €/mês. Vê os planos em Conta > Gerir Subscrição."
    );
  }
  if (formatted.includes("Subscribe to Explorer, Adventure or Guide.")) {
    return formatted.replace(
      "Subscribe to Explorer, Adventure or Guide.",
      "Subscribe from €3.50/month. See plans in Account > Manage Subscription."
    );
  }
  return formatted;
};
